/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchUserProfilesByEmail = /* GraphQL */ `
  query SearchUserProfilesByEmail($email: String!) {
    searchUserProfilesByEmail(email: $email) {
      id
      cognitoId
      owner
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      updatedBy
      sendToApex
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const searchUserProfilesByFamilyName = /* GraphQL */ `
  query SearchUserProfilesByFamilyName($familyName: String!) {
    searchUserProfilesByFamilyName(familyName: $familyName) {
      id
      cognitoId
      owner
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      updatedBy
      sendToApex
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getAccountInformation = /* GraphQL */ `
  query GetAccountInformation($id: ID!) {
    getAccountInformation(id: $id) {
      id
      primaryOwner
      owner
      accountNumber
      accountName
      accountType
      customerType
      accountRequestStatus
      investigationStatus
      apexId
      apexFdid
      apexCatAccountholderType
      apexJson
      accountStatus
      balance {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      permissions {
        id
        accountNumber
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        achDeposit
        updatedBy
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        __typename
      }
      userOrders {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        nextToken
        __typename
      }
      positions {
        items {
          id
          accountNumber
          owner
          underlying
          pricePaid
          isCryptoPosition
          quantity
          marginRequirement
          strategy
          positionLegs {
            side
            quantity
            ratioQuantity
            pricePaid
            legType
            cusip
            marginRequirement
            expiration
            strike
            __typename
          }
          subAccountNumber
          status
          groupUploadOrderId
          createdAt
          updatedAt
          accountInformationPositionsId
          __typename
        }
        nextToken
        __typename
      }
      subAccounts {
        items {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          selfDirected
          balance {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            accountType
            createdAt
            updatedAt
            __typename
          }
          transfers {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              toSubAccountNumber
              amount
              message
              deposit
              status
              cancel
              createdAt
              updatedAt
              subAccountTransfersId
              __typename
            }
            nextToken
            __typename
          }
          commissionCode
          repCode
          newsLetter {
            newsLetter
            portfolio
            __typename
          }
          stock {
            stockSignals
            maxDollarAllocationPerSignal
            maxNumberOfSharesPerSignal
            allOrNone
            roundLotsOnly
            multiplier
            __typename
          }
          option {
            optionSignals
            maxDollarAllocationPerSignal
            maxNumberOfContractsPerSignal
            allOrNone
            multiplier
            __typename
          }
          createdAt
          updatedAt
          accountInformationSubAccountsId
          subAccountBalanceId
          __typename
        }
        nextToken
        __typename
      }
      documentUpload {
        items {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          investigationId
          investigationNote
          submittedBy
          document {
            documentTag
            documentType
            s3uri
            __typename
          }
          approvedBy
          approvalStatus
          createdAt
          updatedAt
          accountInformationDocumentUploadId
          __typename
        }
        nextToken
        __typename
      }
      cryptoTransfer {
        items {
          id
          accountNumber
          owner
          blockchainHash
          clientTransactionId
          currency
          quantity
          receiveAddress {
            hotWalletAddress
            coin
            __typename
          }
          userWalletAddress {
            owner
            address
            nickname
            id
            createdAt
            updatedAt
            __typename
          }
          deposit
          status
          type
          version
          createdAt
          updatedAt
          accountInformationCryptoTransferId
          __typename
        }
        nextToken
        __typename
      }
      selectedWatchlist {
        items {
          id
          accountNumber
          owner
          watchListName
          selectedStocks
          createdAt
          updatedAt
          accountInformationSelectedWatchlistId
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          accountNumber
          owner
          notificationType
          message
          severity
          acknowledged
          star
          sent
          deleted
          toUser
          fromUser
          fromSystem
          ttl
          createdAt
          updatedAt
          accountInformationNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      userProfileIds
      createdAt
      updatedAt
      userProfileAccountsId
      draftUserProfileAccountsId
      accountInformationBalanceId
      accountInformationPermissionsId
      accountInformationAchRelationshipId
      __typename
    }
  }
`;
export const listAccountInformations = /* GraphQL */ `
  query ListAccountInformations(
    $id: ID
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccountInformations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountInformationByPrimaryOwner = /* GraphQL */ `
  query AccountInformationByPrimaryOwner(
    $primaryOwner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByPrimaryOwner(
      primaryOwner: $primaryOwner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountInformationByAccountNumber = /* GraphQL */ `
  query AccountInformationByAccountNumber(
    $accountNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByAccountNumber(
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountInformationByAccountRequestStatus = /* GraphQL */ `
  query AccountInformationByAccountRequestStatus(
    $accountRequestStatus: String!
    $accountNumberAccountName: ModelAccountInformationByAccountRequestStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByAccountRequestStatus(
      accountRequestStatus: $accountRequestStatus
      accountNumberAccountName: $accountNumberAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountInformationByInvestigationStatus = /* GraphQL */ `
  query AccountInformationByInvestigationStatus(
    $investigationStatus: String!
    $accountNumberAccountName: ModelAccountInformationByInvestigationStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByInvestigationStatus(
      investigationStatus: $investigationStatus
      accountNumberAccountName: $accountNumberAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountInformationByApexId = /* GraphQL */ `
  query AccountInformationByApexId(
    $apexId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByApexId(
      apexId: $apexId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountInformationByAccountStatus = /* GraphQL */ `
  query AccountInformationByAccountStatus(
    $accountStatus: String!
    $accountNumberAccountName: ModelAccountInformationByAccountStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByAccountStatus(
      accountStatus: $accountStatus
      accountNumberAccountName: $accountNumberAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchRelationship = /* GraphQL */ `
  query GetAchRelationship($id: ID!) {
    getAchRelationship(id: $id) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      achRelationshipStatic {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      deleted
      nickname
      microDepositTries
      microDeposits
      microDepositStatus
      depositWithdrawalRequests {
        items {
          id
          accountNumber
          owner
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          relationshipId
          amount
          message
          memo
          reason
          iraContributionDistribution {
            contributionType
            applyToPriorYear
            distributionReason
            federalTaxWithholding {
              valueType
              value
              __typename
            }
            stateTaxWithholding {
              valueType
              value
              __typename
            }
            __typename
          }
          isFullDisbursement
          transferId
          deposit
          status
          cancel
          createdAt
          updatedAt
          achRelationshipDepositWithdrawalRequestsId
          __typename
        }
        nextToken
        __typename
      }
      reissueTries
      reissue
      createdAt
      updatedAt
      achRelationshipAchRelationshipStaticId
      achRelationshipAccountInformationId
      __typename
    }
  }
`;
export const listAchRelationships = /* GraphQL */ `
  query ListAchRelationships(
    $id: ID
    $filter: ModelAchRelationshipFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchRelationships(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achRelationshipByAccountNumber = /* GraphQL */ `
  query AchRelationshipByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchRelationshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achRelationshipByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchRelationshipStatic = /* GraphQL */ `
  query GetAchRelationshipStatic($id: ID!) {
    getAchRelationshipStatic(id: $id) {
      id
      accountNumber
      owner
      plaidProcessorToken
      plaidAccountId
      bankRoutingNumber
      bankAccount
      bankAccountOwnerName
      bankAccountType
      deleted
      approvalMethod
      relationshipId
      status
      statusCode
      statusJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAchRelationshipStatics = /* GraphQL */ `
  query ListAchRelationshipStatics(
    $id: ID
    $filter: ModelAchRelationshipStaticFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchRelationshipStatics(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achRelationshipStaticByAccountNumber = /* GraphQL */ `
  query AchRelationshipStaticByAccountNumber(
    $accountNumber: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchRelationshipStaticFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achRelationshipStaticByAccountNumber(
      accountNumber: $accountNumber
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achRelationshipStaticByRelationshipId = /* GraphQL */ `
  query AchRelationshipStaticByRelationshipId(
    $relationshipId: String!
    $accountNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchRelationshipStaticFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achRelationshipStaticByRelationshipId(
      relationshipId: $relationshipId
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achRelationshipStaticByStatus = /* GraphQL */ `
  query AchRelationshipStaticByStatus(
    $status: String!
    $accountNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchRelationshipStaticFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achRelationshipStaticByStatus(
      status: $status
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        plaidProcessorToken
        plaidAccountId
        bankRoutingNumber
        bankAccount
        bankAccountOwnerName
        bankAccountType
        deleted
        approvalMethod
        relationshipId
        status
        statusCode
        statusJson
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchDepositWithdrawalRequest = /* GraphQL */ `
  query GetAchDepositWithdrawalRequest($id: ID!) {
    getAchDepositWithdrawalRequest(id: $id) {
      id
      accountNumber
      owner
      achRelationship {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        achRelationshipStatic {
          id
          accountNumber
          owner
          plaidProcessorToken
          plaidAccountId
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
          __typename
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            relationshipId
            amount
            message
            memo
            reason
            iraContributionDistribution {
              contributionType
              applyToPriorYear
              distributionReason
              federalTaxWithholding {
                valueType
                value
                __typename
              }
              stateTaxWithholding {
                valueType
                value
                __typename
              }
              __typename
            }
            isFullDisbursement
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
            __typename
          }
          nextToken
          __typename
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
        __typename
      }
      relationshipId
      amount
      message
      memo
      reason
      iraContributionDistribution {
        contributionType
        applyToPriorYear
        distributionReason
        federalTaxWithholding {
          valueType
          value
          __typename
        }
        stateTaxWithholding {
          valueType
          value
          __typename
        }
        __typename
      }
      isFullDisbursement
      transferId
      deposit
      status
      cancel
      createdAt
      updatedAt
      achRelationshipDepositWithdrawalRequestsId
      __typename
    }
  }
`;
export const listAchDepositWithdrawalRequests = /* GraphQL */ `
  query ListAchDepositWithdrawalRequests(
    $id: ID
    $filter: ModelAchDepositWithdrawalRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchDepositWithdrawalRequests(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        relationshipId
        amount
        message
        memo
        reason
        iraContributionDistribution {
          contributionType
          applyToPriorYear
          distributionReason
          federalTaxWithholding {
            valueType
            value
            __typename
          }
          stateTaxWithholding {
            valueType
            value
            __typename
          }
          __typename
        }
        isFullDisbursement
        transferId
        deposit
        status
        cancel
        createdAt
        updatedAt
        achRelationshipDepositWithdrawalRequestsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achDepositWithdrawalRequestByAccountNumber = /* GraphQL */ `
  query AchDepositWithdrawalRequestByAccountNumber(
    $accountNumber: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchDepositWithdrawalRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achDepositWithdrawalRequestByAccountNumber(
      accountNumber: $accountNumber
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        relationshipId
        amount
        message
        memo
        reason
        iraContributionDistribution {
          contributionType
          applyToPriorYear
          distributionReason
          federalTaxWithholding {
            valueType
            value
            __typename
          }
          stateTaxWithholding {
            valueType
            value
            __typename
          }
          __typename
        }
        isFullDisbursement
        transferId
        deposit
        status
        cancel
        createdAt
        updatedAt
        achRelationshipDepositWithdrawalRequestsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achDepositWithdrawalRequestByTransferId = /* GraphQL */ `
  query AchDepositWithdrawalRequestByTransferId(
    $transferId: String!
    $accountNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchDepositWithdrawalRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achDepositWithdrawalRequestByTransferId(
      transferId: $transferId
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        relationshipId
        amount
        message
        memo
        reason
        iraContributionDistribution {
          contributionType
          applyToPriorYear
          distributionReason
          federalTaxWithholding {
            valueType
            value
            __typename
          }
          stateTaxWithholding {
            valueType
            value
            __typename
          }
          __typename
        }
        isFullDisbursement
        transferId
        deposit
        status
        cancel
        createdAt
        updatedAt
        achRelationshipDepositWithdrawalRequestsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBalance = /* GraphQL */ `
  query GetBalance($id: ID!) {
    getBalance(id: $id) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      updateFlag
      accountType
      pendingTransfers {
        deposit
        amount
        achDepositWithdrawalRequestId
        __typename
      }
      createdAt
      updatedAt
      balanceAccountInformationId
      __typename
    }
  }
`;
export const listBalances = /* GraphQL */ `
  query ListBalances(
    $id: ID
    $filter: ModelBalanceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBalances(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const balanceByAccountNumber = /* GraphQL */ `
  query BalanceByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBalanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    balanceByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const balanceByUpdateFlag = /* GraphQL */ `
  query BalanceByUpdateFlag(
    $updateFlag: UpdateFlag!
    $accountNumberId: ModelBalanceByUpdateFlagCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBalanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    balanceByUpdateFlag(
      updateFlag: $updateFlag
      accountNumberId: $accountNumberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        updateFlag
        accountType
        pendingTransfers {
          deposit
          amount
          achDepositWithdrawalRequestId
          __typename
        }
        createdAt
        updatedAt
        balanceAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPositionSod = /* GraphQL */ `
  query GetPositionSod($id: ID!) {
    getPositionSod(id: $id) {
      id
      accountNumber
      owner
      processDate
      officeCode
      registeredRepCode
      accountType
      symbol
      cusip
      tradeQuantity
      settleQuantity
      securityTypeCode
      description
      marginEligibleCode
      closingPrice
      conversionFactor
      underlyingCusip
      optionSymbolRoot
      optionContractDate
      strikePrice
      callPut
      expirationDeliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPositionSods = /* GraphQL */ `
  query ListPositionSods(
    $id: ID
    $filter: ModelPositionSodFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPositionSods(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        processDate
        officeCode
        registeredRepCode
        accountType
        symbol
        cusip
        tradeQuantity
        settleQuantity
        securityTypeCode
        description
        marginEligibleCode
        closingPrice
        conversionFactor
        underlyingCusip
        optionSymbolRoot
        optionContractDate
        strikePrice
        callPut
        expirationDeliveryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const positionSodByAccountNumber = /* GraphQL */ `
  query PositionSodByAccountNumber(
    $accountNumber: String!
    $optionSymbolRootId: ModelPositionSodByAccountNumberCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPositionSodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    positionSodByAccountNumber(
      accountNumber: $accountNumber
      optionSymbolRootId: $optionSymbolRootId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        processDate
        officeCode
        registeredRepCode
        accountType
        symbol
        cusip
        tradeQuantity
        settleQuantity
        securityTypeCode
        description
        marginEligibleCode
        closingPrice
        conversionFactor
        underlyingCusip
        optionSymbolRoot
        optionContractDate
        strikePrice
        callPut
        expirationDeliveryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPosition = /* GraphQL */ `
  query GetPosition($id: ID!) {
    getPosition(id: $id) {
      id
      accountNumber
      owner
      underlying
      pricePaid
      isCryptoPosition
      quantity
      marginRequirement
      strategy
      positionLegs {
        side
        quantity
        ratioQuantity
        pricePaid
        legType
        cusip
        marginRequirement
        expiration
        strike
        __typename
      }
      subAccountNumber
      status
      groupUploadOrderId
      createdAt
      updatedAt
      accountInformationPositionsId
      __typename
    }
  }
`;
export const listPositions = /* GraphQL */ `
  query ListPositions(
    $id: ID
    $filter: ModelPositionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPositions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        underlying
        pricePaid
        isCryptoPosition
        quantity
        marginRequirement
        strategy
        positionLegs {
          side
          quantity
          ratioQuantity
          pricePaid
          legType
          cusip
          marginRequirement
          expiration
          strike
          __typename
        }
        subAccountNumber
        status
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationPositionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const positionByAccountNumber = /* GraphQL */ `
  query PositionByAccountNumber(
    $accountNumber: String!
    $underlyingId: ModelPositionByAccountNumberCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    positionByAccountNumber(
      accountNumber: $accountNumber
      underlyingId: $underlyingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        underlying
        pricePaid
        isCryptoPosition
        quantity
        marginRequirement
        strategy
        positionLegs {
          side
          quantity
          ratioQuantity
          pricePaid
          legType
          cusip
          marginRequirement
          expiration
          strike
          __typename
        }
        subAccountNumber
        status
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationPositionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const positionByIsCryptoPosition = /* GraphQL */ `
  query PositionByIsCryptoPosition(
    $isCryptoPosition: String!
    $accountNumberId: ModelPositionByIsCryptoPositionCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    positionByIsCryptoPosition(
      isCryptoPosition: $isCryptoPosition
      accountNumberId: $accountNumberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        underlying
        pricePaid
        isCryptoPosition
        quantity
        marginRequirement
        strategy
        positionLegs {
          side
          quantity
          ratioQuantity
          pricePaid
          legType
          cusip
          marginRequirement
          expiration
          strike
          __typename
        }
        subAccountNumber
        status
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationPositionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const positionbySubAccountNumber = /* GraphQL */ `
  query PositionbySubAccountNumber(
    $subAccountNumber: String!
    $accountNumberId: ModelPositionBySubAccountNumberCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    positionbySubAccountNumber(
      subAccountNumber: $subAccountNumber
      accountNumberId: $accountNumberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        underlying
        pricePaid
        isCryptoPosition
        quantity
        marginRequirement
        strategy
        positionLegs {
          side
          quantity
          ratioQuantity
          pricePaid
          legType
          cusip
          marginRequirement
          expiration
          strike
          __typename
        }
        subAccountNumber
        status
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationPositionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const positionByStatus = /* GraphQL */ `
  query PositionByStatus(
    $status: Status!
    $underlyingId: ModelPositionByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    positionByStatus(
      status: $status
      underlyingId: $underlyingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        underlying
        pricePaid
        isCryptoPosition
        quantity
        marginRequirement
        strategy
        positionLegs {
          side
          quantity
          ratioQuantity
          pricePaid
          legType
          cusip
          marginRequirement
          expiration
          strike
          __typename
        }
        subAccountNumber
        status
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationPositionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubAccount = /* GraphQL */ `
  query GetSubAccount($id: ID!) {
    getSubAccount(id: $id) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      selfDirected
      balance {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        accountType
        createdAt
        updatedAt
        __typename
      }
      transfers {
        items {
          id
          accountNumber
          owner
          subAccountNumber
          toSubAccountNumber
          amount
          message
          deposit
          status
          cancel
          createdAt
          updatedAt
          subAccountTransfersId
          __typename
        }
        nextToken
        __typename
      }
      commissionCode
      repCode
      newsLetter {
        newsLetter
        portfolio
        __typename
      }
      stock {
        stockSignals
        maxDollarAllocationPerSignal
        maxNumberOfSharesPerSignal
        allOrNone
        roundLotsOnly
        multiplier
        __typename
      }
      option {
        optionSignals
        maxDollarAllocationPerSignal
        maxNumberOfContractsPerSignal
        allOrNone
        multiplier
        __typename
      }
      createdAt
      updatedAt
      accountInformationSubAccountsId
      subAccountBalanceId
      __typename
    }
  }
`;
export const listSubAccounts = /* GraphQL */ `
  query ListSubAccounts(
    $id: ID
    $filter: ModelSubAccountFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSubAccounts(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        selfDirected
        balance {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          accountType
          createdAt
          updatedAt
          __typename
        }
        transfers {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            toSubAccountNumber
            amount
            message
            deposit
            status
            cancel
            createdAt
            updatedAt
            subAccountTransfersId
            __typename
          }
          nextToken
          __typename
        }
        commissionCode
        repCode
        newsLetter {
          newsLetter
          portfolio
          __typename
        }
        stock {
          stockSignals
          maxDollarAllocationPerSignal
          maxNumberOfSharesPerSignal
          allOrNone
          roundLotsOnly
          multiplier
          __typename
        }
        option {
          optionSignals
          maxDollarAllocationPerSignal
          maxNumberOfContractsPerSignal
          allOrNone
          multiplier
          __typename
        }
        createdAt
        updatedAt
        accountInformationSubAccountsId
        subAccountBalanceId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subAccountByAccountNumber = /* GraphQL */ `
  query SubAccountByAccountNumber(
    $accountNumber: String!
    $subAccountName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subAccountByAccountNumber(
      accountNumber: $accountNumber
      subAccountName: $subAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        selfDirected
        balance {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          accountType
          createdAt
          updatedAt
          __typename
        }
        transfers {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            toSubAccountNumber
            amount
            message
            deposit
            status
            cancel
            createdAt
            updatedAt
            subAccountTransfersId
            __typename
          }
          nextToken
          __typename
        }
        commissionCode
        repCode
        newsLetter {
          newsLetter
          portfolio
          __typename
        }
        stock {
          stockSignals
          maxDollarAllocationPerSignal
          maxNumberOfSharesPerSignal
          allOrNone
          roundLotsOnly
          multiplier
          __typename
        }
        option {
          optionSignals
          maxDollarAllocationPerSignal
          maxNumberOfContractsPerSignal
          allOrNone
          multiplier
          __typename
        }
        createdAt
        updatedAt
        accountInformationSubAccountsId
        subAccountBalanceId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subAccountBySubAccountNumber = /* GraphQL */ `
  query SubAccountBySubAccountNumber(
    $subAccountNumber: String!
    $subAccountName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subAccountBySubAccountNumber(
      subAccountNumber: $subAccountNumber
      subAccountName: $subAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        selfDirected
        balance {
          id
          accountNumber
          owner
          subAccountName
          subAccountNumber
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          accountType
          createdAt
          updatedAt
          __typename
        }
        transfers {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            toSubAccountNumber
            amount
            message
            deposit
            status
            cancel
            createdAt
            updatedAt
            subAccountTransfersId
            __typename
          }
          nextToken
          __typename
        }
        commissionCode
        repCode
        newsLetter {
          newsLetter
          portfolio
          __typename
        }
        stock {
          stockSignals
          maxDollarAllocationPerSignal
          maxNumberOfSharesPerSignal
          allOrNone
          roundLotsOnly
          multiplier
          __typename
        }
        option {
          optionSignals
          maxDollarAllocationPerSignal
          maxNumberOfContractsPerSignal
          allOrNone
          multiplier
          __typename
        }
        createdAt
        updatedAt
        accountInformationSubAccountsId
        subAccountBalanceId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubAccountTransfer = /* GraphQL */ `
  query GetSubAccountTransfer($id: ID!) {
    getSubAccountTransfer(id: $id) {
      id
      accountNumber
      owner
      subAccountNumber
      toSubAccountNumber
      amount
      message
      deposit
      status
      cancel
      createdAt
      updatedAt
      subAccountTransfersId
      __typename
    }
  }
`;
export const listSubAccountTransfers = /* GraphQL */ `
  query ListSubAccountTransfers(
    $id: ID
    $filter: ModelSubAccountTransferFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSubAccountTransfers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        toSubAccountNumber
        amount
        message
        deposit
        status
        cancel
        createdAt
        updatedAt
        subAccountTransfersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const SubAccountTransferByAccountNumber = /* GraphQL */ `
  query SubAccountTransferByAccountNumber(
    $accountNumber: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubAccountTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SubAccountTransferByAccountNumber(
      accountNumber: $accountNumber
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        toSubAccountNumber
        amount
        message
        deposit
        status
        cancel
        createdAt
        updatedAt
        subAccountTransfersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubAccountBalance = /* GraphQL */ `
  query GetSubAccountBalance($id: ID!) {
    getSubAccountBalance(id: $id) {
      id
      accountNumber
      owner
      subAccountName
      subAccountNumber
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      optionBuyingPowerInternal
      stockBuyingPowerInternal
      accountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubAccountBalances = /* GraphQL */ `
  query ListSubAccountBalances(
    $id: ID
    $filter: ModelSubAccountBalanceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSubAccountBalances(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        accountType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subAccountBalanceBySubAccountNumber = /* GraphQL */ `
  query SubAccountBalanceBySubAccountNumber(
    $subAccountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubAccountBalanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subAccountBalanceBySubAccountNumber(
      subAccountNumber: $subAccountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountName
        subAccountNumber
        overnightBuyingPowerID
        firm
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerIssued
        overnightFactorIssued
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        moneyMarketTradeBalance
        freeCash
        sma
        availableToWithdraw
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        netLiquidity
        pendingDebitInterest
        pendingDebitDividends
        fullyPaidUnsettledFunds
        cashOnOrders
        buyingPowerOnOrders
        marginExcessEquitySod
        cashExcessEquitySod
        netBalanceSod
        optionBuyingPowerInternal
        stockBuyingPowerInternal
        accountType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserPermissions = /* GraphQL */ `
  query GetUserPermissions($id: ID!) {
    getUserPermissions(id: $id) {
      id
      accountNumber
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      owner
      systemAccess
      equityTrading
      optionsTrading
      cryptoTrading
      margin
      securitiesLending
      optionsLevel
      exitOnlyTrades
      restrictReason
      allowCancelOrder
      allowModifyOrder
      achWithdrawal
      patternDayTrader
      achApproval
      profileStatus
      betaFeatures
      achDeposit
      updatedBy
      createdAt
      updatedAt
      userPermissionsAccountInformationId
      __typename
    }
  }
`;
export const listUserPermissions = /* GraphQL */ `
  query ListUserPermissions(
    $id: ID
    $filter: ModelUserPermissionsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserPermissions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        achDeposit
        updatedBy
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userPermissionsByAccountNumber = /* GraphQL */ `
  query UserPermissionsByAccountNumber(
    $accountNumber: String!
    $systemAccess: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserPermissionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userPermissionsByAccountNumber(
      accountNumber: $accountNumber
      systemAccess: $systemAccess
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        achDeposit
        updatedBy
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocumentUpload = /* GraphQL */ `
  query GetDocumentUpload($id: ID!) {
    getDocumentUpload(id: $id) {
      id
      accountNumber
      owner
      accountInformation {
        id
        primaryOwner
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexFdid
        apexCatAccountholderType
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          updatedBy
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        userOrders {
          items {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          nextToken
          __typename
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            isCryptoPosition
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              cusip
              marginRequirement
              expiration
              strike
              __typename
            }
            subAccountNumber
            status
            groupUploadOrderId
            createdAt
            updatedAt
            accountInformationPositionsId
            __typename
          }
          nextToken
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        cryptoTransfer {
          items {
            id
            accountNumber
            owner
            blockchainHash
            clientTransactionId
            currency
            quantity
            receiveAddress {
              hotWalletAddress
              coin
              __typename
            }
            userWalletAddress {
              owner
              address
              nickname
              id
              createdAt
              updatedAt
              __typename
            }
            deposit
            status
            type
            version
            createdAt
            updatedAt
            accountInformationCryptoTransferId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        notifications {
          items {
            id
            accountNumber
            owner
            notificationType
            message
            severity
            acknowledged
            star
            sent
            deleted
            toUser
            fromUser
            fromSystem
            ttl
            createdAt
            updatedAt
            accountInformationNotificationsId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          accountInformation {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      investigationId
      investigationNote
      submittedBy
      document {
        documentTag
        documentType
        s3uri
        __typename
      }
      approvedBy
      approvalStatus
      createdAt
      updatedAt
      accountInformationDocumentUploadId
      __typename
    }
  }
`;
export const listDocumentUploads = /* GraphQL */ `
  query ListDocumentUploads(
    $id: ID
    $filter: ModelDocumentUploadFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDocumentUploads(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        investigationId
        investigationNote
        submittedBy
        document {
          documentTag
          documentType
          s3uri
          __typename
        }
        approvedBy
        approvalStatus
        createdAt
        updatedAt
        accountInformationDocumentUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentUploadByAccountNumber = /* GraphQL */ `
  query DocumentUploadByAccountNumber(
    $accountNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentUploadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentUploadByAccountNumber(
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        accountInformation {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        investigationId
        investigationNote
        submittedBy
        document {
          documentTag
          documentType
          s3uri
          __typename
        }
        approvedBy
        approvalStatus
        createdAt
        updatedAt
        accountInformationDocumentUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserStatements = /* GraphQL */ `
  query GetUserStatements($id: ID!) {
    getUserStatements(id: $id) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      pageCount
      pageCountDisplay
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserStatements = /* GraphQL */ `
  query ListUserStatements(
    $id: ID
    $filter: ModelUserStatementsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserStatements(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        documentId
        correspondentCode
        branchCode
        documentCategory
        documentType
        taxIds
        fileName
        documentDate
        documentUrl
        pageCount
        pageCountDisplay
        ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userStatementsByAccountNumber = /* GraphQL */ `
  query UserStatementsByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserStatementsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userStatementsByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        documentId
        correspondentCode
        branchCode
        documentCategory
        documentType
        taxIds
        fileName
        documentDate
        documentUrl
        pageCount
        pageCountDisplay
        ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getForm = /* GraphQL */ `
  query GetForm($id: ID!) {
    getForm(id: $id) {
      id
      accountNumber
      owner
      userProfileId
      onboardingRequested
      marginRequested
      cryptoRequested
      formsRequested
      requestedOptionLevels
      approvedOptionLevels
      terms
      approvalStatus
      marginStatus
      cryptoStatus
      approvedBy
      message
      foreignDueDiligence {
        initialContact
        referredName
        referredRelationship
        businessNature
        accountActivityType
        referredToBroker
        primaryBanking
        initialDepositType
        valueInitialDeposit
        expectedWithdrawals
        __typename
      }
      entityDueDiligence {
        accountName
        countryOfIncorporation
        businessLocations
        hasRelatedAccounts
        relatedAccounts {
          accountNumber
          entityName
          __typename
        }
        politicallyExposedPersons {
          legalName
          role
          politicalTitle
          politicalOrganization
          immediateFamily
          __typename
        }
        primaryEntityAccountActivity
        expectedWithdrawalFrequency
        willTransactForeignBonds
        willTransactLowPricedSecurities
        initialDepositAmount
        initialDepositSource
        additionalAccounts {
          institutionNames
          scopeOfBusiness
          scopeOfBusinessClarification
          primaryOngoingFundingSource
          confirmEntityDoesNotIssueBearerShares
          __typename
        }
        entityOrAssociatesHaveNegativeNews
        entityOrAssociatesNegativeNewsInfo
        registeredRepresentativeApproverName
        assessedRiskRating
        __typename
      }
      updatedBy
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listForms = /* GraphQL */ `
  query ListForms(
    $id: ID
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listForms(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        userProfileId
        onboardingRequested
        marginRequested
        cryptoRequested
        formsRequested
        requestedOptionLevels
        approvedOptionLevels
        terms
        approvalStatus
        marginStatus
        cryptoStatus
        approvedBy
        message
        foreignDueDiligence {
          initialContact
          referredName
          referredRelationship
          businessNature
          accountActivityType
          referredToBroker
          primaryBanking
          initialDepositType
          valueInitialDeposit
          expectedWithdrawals
          __typename
        }
        entityDueDiligence {
          accountName
          countryOfIncorporation
          businessLocations
          hasRelatedAccounts
          relatedAccounts {
            accountNumber
            entityName
            __typename
          }
          politicallyExposedPersons {
            legalName
            role
            politicalTitle
            politicalOrganization
            immediateFamily
            __typename
          }
          primaryEntityAccountActivity
          expectedWithdrawalFrequency
          willTransactForeignBonds
          willTransactLowPricedSecurities
          initialDepositAmount
          initialDepositSource
          additionalAccounts {
            institutionNames
            scopeOfBusiness
            scopeOfBusinessClarification
            primaryOngoingFundingSource
            confirmEntityDoesNotIssueBearerShares
            __typename
          }
          entityOrAssociatesHaveNegativeNews
          entityOrAssociatesNegativeNewsInfo
          registeredRepresentativeApproverName
          assessedRiskRating
          __typename
        }
        updatedBy
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const formByAccountNumber = /* GraphQL */ `
  query FormByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    formByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        userProfileId
        onboardingRequested
        marginRequested
        cryptoRequested
        formsRequested
        requestedOptionLevels
        approvedOptionLevels
        terms
        approvalStatus
        marginStatus
        cryptoStatus
        approvedBy
        message
        foreignDueDiligence {
          initialContact
          referredName
          referredRelationship
          businessNature
          accountActivityType
          referredToBroker
          primaryBanking
          initialDepositType
          valueInitialDeposit
          expectedWithdrawals
          __typename
        }
        entityDueDiligence {
          accountName
          countryOfIncorporation
          businessLocations
          hasRelatedAccounts
          relatedAccounts {
            accountNumber
            entityName
            __typename
          }
          politicallyExposedPersons {
            legalName
            role
            politicalTitle
            politicalOrganization
            immediateFamily
            __typename
          }
          primaryEntityAccountActivity
          expectedWithdrawalFrequency
          willTransactForeignBonds
          willTransactLowPricedSecurities
          initialDepositAmount
          initialDepositSource
          additionalAccounts {
            institutionNames
            scopeOfBusiness
            scopeOfBusinessClarification
            primaryOngoingFundingSource
            confirmEntityDoesNotIssueBearerShares
            __typename
          }
          entityOrAssociatesHaveNegativeNews
          entityOrAssociatesNegativeNewsInfo
          registeredRepresentativeApproverName
          assessedRiskRating
          __typename
        }
        updatedBy
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const formByApprovalStatus = /* GraphQL */ `
  query FormByApprovalStatus(
    $approvalStatus: ApprovalStatus!
    $accountNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    formByApprovalStatus(
      approvalStatus: $approvalStatus
      accountNumber: $accountNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        userProfileId
        onboardingRequested
        marginRequested
        cryptoRequested
        formsRequested
        requestedOptionLevels
        approvedOptionLevels
        terms
        approvalStatus
        marginStatus
        cryptoStatus
        approvedBy
        message
        foreignDueDiligence {
          initialContact
          referredName
          referredRelationship
          businessNature
          accountActivityType
          referredToBroker
          primaryBanking
          initialDepositType
          valueInitialDeposit
          expectedWithdrawals
          __typename
        }
        entityDueDiligence {
          accountName
          countryOfIncorporation
          businessLocations
          hasRelatedAccounts
          relatedAccounts {
            accountNumber
            entityName
            __typename
          }
          politicallyExposedPersons {
            legalName
            role
            politicalTitle
            politicalOrganization
            immediateFamily
            __typename
          }
          primaryEntityAccountActivity
          expectedWithdrawalFrequency
          willTransactForeignBonds
          willTransactLowPricedSecurities
          initialDepositAmount
          initialDepositSource
          additionalAccounts {
            institutionNames
            scopeOfBusiness
            scopeOfBusinessClarification
            primaryOngoingFundingSource
            confirmEntityDoesNotIssueBearerShares
            __typename
          }
          entityOrAssociatesHaveNegativeNews
          entityOrAssociatesNegativeNewsInfo
          registeredRepresentativeApproverName
          assessedRiskRating
          __typename
        }
        updatedBy
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWatchlist = /* GraphQL */ `
  query GetWatchlist($id: ID!) {
    getWatchlist(id: $id) {
      id
      accountNumber
      owner
      watchListName
      selectedStocks
      createdAt
      updatedAt
      accountInformationSelectedWatchlistId
      __typename
    }
  }
`;
export const listWatchlists = /* GraphQL */ `
  query ListWatchlists(
    $id: ID
    $filter: ModelWatchlistFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listWatchlists(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        watchListName
        selectedStocks
        createdAt
        updatedAt
        accountInformationSelectedWatchlistId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const WatchlistByAccountNumber = /* GraphQL */ `
  query WatchlistByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchlistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    WatchlistByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        watchListName
        selectedStocks
        createdAt
        updatedAt
        accountInformationSelectedWatchlistId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotifications = /* GraphQL */ `
  query GetNotifications($id: ID!) {
    getNotifications(id: $id) {
      id
      accountNumber
      owner
      notificationType
      message
      severity
      acknowledged
      star
      sent
      deleted
      toUser
      fromUser
      fromSystem
      ttl
      createdAt
      updatedAt
      accountInformationNotificationsId
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $id: ID
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNotifications(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        notificationType
        message
        severity
        acknowledged
        star
        sent
        deleted
        toUser
        fromUser
        fromSystem
        ttl
        createdAt
        updatedAt
        accountInformationNotificationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByAccountNumber = /* GraphQL */ `
  query NotificationsByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        notificationType
        message
        severity
        acknowledged
        star
        sent
        deleted
        toUser
        fromUser
        fromSystem
        ttl
        createdAt
        updatedAt
        accountInformationNotificationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserStatementsRequest = /* GraphQL */ `
  query GetUserStatementsRequest($id: ID!) {
    getUserStatementsRequest(id: $id) {
      id
      accountNumber
      owner
      documentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserStatementsRequests = /* GraphQL */ `
  query ListUserStatementsRequests(
    $id: ID
    $filter: ModelUserStatementsRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserStatementsRequests(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        documentCategory
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserStatementDocuments = /* GraphQL */ `
  query GetUserStatementDocuments($id: ID!) {
    getUserStatementDocuments(id: $id) {
      id
      accountNumber
      owner
      documentId
      correspondentCode
      branchCode
      documentCategory
      documentType
      taxIds
      fileName
      documentDate
      documentUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserStatementDocuments = /* GraphQL */ `
  query ListUserStatementDocuments(
    $id: ID
    $filter: ModelUserStatementDocumentsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserStatementDocuments(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        documentId
        correspondentCode
        branchCode
        documentCategory
        documentType
        taxIds
        fileName
        documentDate
        documentUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userStatementDocumentsByAccountNumber = /* GraphQL */ `
  query UserStatementDocumentsByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserStatementDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userStatementDocumentsByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        documentId
        correspondentCode
        branchCode
        documentCategory
        documentType
        taxIds
        fileName
        documentDate
        documentUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCryptoTransfer = /* GraphQL */ `
  query GetCryptoTransfer($id: ID!) {
    getCryptoTransfer(id: $id) {
      id
      accountNumber
      owner
      blockchainHash
      clientTransactionId
      currency
      quantity
      receiveAddress {
        hotWalletAddress
        coin
        __typename
      }
      userWalletAddress {
        owner
        address
        nickname
        id
        createdAt
        updatedAt
        __typename
      }
      deposit
      status
      type
      version
      createdAt
      updatedAt
      accountInformationCryptoTransferId
      __typename
    }
  }
`;
export const listCryptoTransfers = /* GraphQL */ `
  query ListCryptoTransfers(
    $id: ID
    $filter: ModelCryptoTransferFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCryptoTransfers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        blockchainHash
        clientTransactionId
        currency
        quantity
        receiveAddress {
          hotWalletAddress
          coin
          __typename
        }
        userWalletAddress {
          owner
          address
          nickname
          id
          createdAt
          updatedAt
          __typename
        }
        deposit
        status
        type
        version
        createdAt
        updatedAt
        accountInformationCryptoTransferId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cryptoTransferByAccountNumber = /* GraphQL */ `
  query CryptoTransferByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCryptoTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cryptoTransferByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        blockchainHash
        clientTransactionId
        currency
        quantity
        receiveAddress {
          hotWalletAddress
          coin
          __typename
        }
        userWalletAddress {
          owner
          address
          nickname
          id
          createdAt
          updatedAt
          __typename
        }
        deposit
        status
        type
        version
        createdAt
        updatedAt
        accountInformationCryptoTransferId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserWalletAddress = /* GraphQL */ `
  query GetUserWalletAddress($id: ID!) {
    getUserWalletAddress(id: $id) {
      owner
      address
      nickname
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserWalletAddresses = /* GraphQL */ `
  query ListUserWalletAddresses(
    $filter: ModelUserWalletAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserWalletAddresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        owner
        address
        nickname
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStock = /* GraphQL */ `
  query GetStock($id: ID!, $symbol: String!) {
    getStock(id: $id, symbol: $symbol) {
      id
      ttl
      symbol
      description
      country
      opol
      currency
      cfi
      priceIncrements
      tradingHours
      autocompleteWeight
      msIndustryCode
      msNaics
      msSic
      nasdaqRawType
      subtypes
      testInstrument
      options {
        items {
          id
          ttl
          underlying
          symbol
          country
          opol
          currency
          cfi
          multiplier
          spc
          mmy
          expiration
          lastTrade
          strike
          optionType
          expirationStyle
          settlementStyle
          priceIncrements
          tradingHours
          autocompleteWeight
          shortSaleRestriction
          tradingStatus
          statusReason
          haltStartTime
          haltEndTime
          high52WeekPrice
          low52WeekPrice
          highLimitPrice
          lowLimitPrice
          bidTime
          bidExchangeCode
          bidPrice
          bidSize
          askTime
          askExchangeCode
          askPrice
          askSize
          tradeTime
          tradeExchangeCode
          tradePrice
          tradeChange
          tradeSize
          tradeDayVolume
          tradeDayTurnover
          tradeTickTime
          extendedTradingHours
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      expirations {
        items {
          id
          ttl
          symbol
          expiration
          expirationStyle
          settlementStyle
          strikes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStocks = /* GraphQL */ `
  query ListStocks(
    $id: ID
    $symbol: ModelStringKeyConditionInput
    $filter: ModelStockFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStocks(
      id: $id
      symbol: $symbol
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        ttl
        symbol
        description
        country
        opol
        currency
        cfi
        priceIncrements
        tradingHours
        autocompleteWeight
        msIndustryCode
        msNaics
        msSic
        nasdaqRawType
        subtypes
        testInstrument
        options {
          items {
            id
            ttl
            underlying
            symbol
            country
            opol
            currency
            cfi
            multiplier
            spc
            mmy
            expiration
            lastTrade
            strike
            optionType
            expirationStyle
            settlementStyle
            priceIncrements
            tradingHours
            autocompleteWeight
            shortSaleRestriction
            tradingStatus
            statusReason
            haltStartTime
            haltEndTime
            high52WeekPrice
            low52WeekPrice
            highLimitPrice
            lowLimitPrice
            bidTime
            bidExchangeCode
            bidPrice
            bidSize
            askTime
            askExchangeCode
            askPrice
            askSize
            tradeTime
            tradeExchangeCode
            tradePrice
            tradeChange
            tradeSize
            tradeDayVolume
            tradeDayTurnover
            tradeTickTime
            extendedTradingHours
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        expirations {
          items {
            id
            ttl
            symbol
            expiration
            expirationStyle
            settlementStyle
            strikes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        shortSaleRestriction
        tradingStatus
        statusReason
        haltStartTime
        haltEndTime
        high52WeekPrice
        low52WeekPrice
        highLimitPrice
        lowLimitPrice
        bidTime
        bidExchangeCode
        bidPrice
        bidSize
        askTime
        askExchangeCode
        askPrice
        askSize
        tradeTime
        tradeExchangeCode
        tradePrice
        tradeChange
        tradeSize
        tradeDayVolume
        tradeDayTurnover
        tradeTickTime
        extendedTradingHours
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const stockBySymbol = /* GraphQL */ `
  query StockBySymbol(
    $symbol: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStockFilterInput
    $limit: Int
    $nextToken: String
  ) {
    stockBySymbol(
      symbol: $symbol
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ttl
        symbol
        description
        country
        opol
        currency
        cfi
        priceIncrements
        tradingHours
        autocompleteWeight
        msIndustryCode
        msNaics
        msSic
        nasdaqRawType
        subtypes
        testInstrument
        options {
          items {
            id
            ttl
            underlying
            symbol
            country
            opol
            currency
            cfi
            multiplier
            spc
            mmy
            expiration
            lastTrade
            strike
            optionType
            expirationStyle
            settlementStyle
            priceIncrements
            tradingHours
            autocompleteWeight
            shortSaleRestriction
            tradingStatus
            statusReason
            haltStartTime
            haltEndTime
            high52WeekPrice
            low52WeekPrice
            highLimitPrice
            lowLimitPrice
            bidTime
            bidExchangeCode
            bidPrice
            bidSize
            askTime
            askExchangeCode
            askPrice
            askSize
            tradeTime
            tradeExchangeCode
            tradePrice
            tradeChange
            tradeSize
            tradeDayVolume
            tradeDayTurnover
            tradeTickTime
            extendedTradingHours
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        expirations {
          items {
            id
            ttl
            symbol
            expiration
            expirationStyle
            settlementStyle
            strikes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        shortSaleRestriction
        tradingStatus
        statusReason
        haltStartTime
        haltEndTime
        high52WeekPrice
        low52WeekPrice
        highLimitPrice
        lowLimitPrice
        bidTime
        bidExchangeCode
        bidPrice
        bidSize
        askTime
        askExchangeCode
        askPrice
        askSize
        tradeTime
        tradeExchangeCode
        tradePrice
        tradeChange
        tradeSize
        tradeDayVolume
        tradeDayTurnover
        tradeTickTime
        extendedTradingHours
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchStocks = /* GraphQL */ `
  query SearchStocks(
    $filter: SearchableStockFilterInput
    $sort: [SearchableStockSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableStockAggregationInput]
  ) {
    searchStocks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        ttl
        symbol
        description
        country
        opol
        currency
        cfi
        priceIncrements
        tradingHours
        autocompleteWeight
        msIndustryCode
        msNaics
        msSic
        nasdaqRawType
        subtypes
        testInstrument
        options {
          items {
            id
            ttl
            underlying
            symbol
            country
            opol
            currency
            cfi
            multiplier
            spc
            mmy
            expiration
            lastTrade
            strike
            optionType
            expirationStyle
            settlementStyle
            priceIncrements
            tradingHours
            autocompleteWeight
            shortSaleRestriction
            tradingStatus
            statusReason
            haltStartTime
            haltEndTime
            high52WeekPrice
            low52WeekPrice
            highLimitPrice
            lowLimitPrice
            bidTime
            bidExchangeCode
            bidPrice
            bidSize
            askTime
            askExchangeCode
            askPrice
            askSize
            tradeTime
            tradeExchangeCode
            tradePrice
            tradeChange
            tradeSize
            tradeDayVolume
            tradeDayTurnover
            tradeTickTime
            extendedTradingHours
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        expirations {
          items {
            id
            ttl
            symbol
            expiration
            expirationStyle
            settlementStyle
            strikes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        shortSaleRestriction
        tradingStatus
        statusReason
        haltStartTime
        haltEndTime
        high52WeekPrice
        low52WeekPrice
        highLimitPrice
        lowLimitPrice
        bidTime
        bidExchangeCode
        bidPrice
        bidSize
        askTime
        askExchangeCode
        askPrice
        askSize
        tradeTime
        tradeExchangeCode
        tradePrice
        tradeChange
        tradeSize
        tradeDayVolume
        tradeDayTurnover
        tradeTickTime
        extendedTradingHours
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getOptionUnderlying = /* GraphQL */ `
  query GetOptionUnderlying($id: ID!, $underlying: String!) {
    getOptionUnderlying(id: $id, underlying: $underlying) {
      id
      ttl
      underlying
      description
      autocompleteWeight
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOptionUnderlyings = /* GraphQL */ `
  query ListOptionUnderlyings(
    $id: ID
    $underlying: ModelStringKeyConditionInput
    $filter: ModelOptionUnderlyingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOptionUnderlyings(
      id: $id
      underlying: $underlying
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        ttl
        underlying
        description
        autocompleteWeight
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const optionUnderlyingByUnderlying = /* GraphQL */ `
  query OptionUnderlyingByUnderlying(
    $underlying: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionUnderlyingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionUnderlyingByUnderlying(
      underlying: $underlying
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ttl
        underlying
        description
        autocompleteWeight
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchOptionUnderlyings = /* GraphQL */ `
  query SearchOptionUnderlyings(
    $filter: SearchableOptionUnderlyingFilterInput
    $sort: [SearchableOptionUnderlyingSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOptionUnderlyingAggregationInput]
  ) {
    searchOptionUnderlyings(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        ttl
        underlying
        description
        autocompleteWeight
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getExpiration = /* GraphQL */ `
  query GetExpiration($id: ID!, $symbol: String!, $expiration: String!) {
    getExpiration(id: $id, symbol: $symbol, expiration: $expiration) {
      id
      ttl
      symbol
      expiration
      expirationStyle
      settlementStyle
      strikes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listExpirations = /* GraphQL */ `
  query ListExpirations(
    $id: ID
    $symbolExpiration: ModelExpirationPrimaryCompositeKeyConditionInput
    $filter: ModelExpirationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listExpirations(
      id: $id
      symbolExpiration: $symbolExpiration
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        ttl
        symbol
        expiration
        expirationStyle
        settlementStyle
        strikes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const expirationsByUnderlying = /* GraphQL */ `
  query ExpirationsByUnderlying(
    $symbol: String!
    $expirationId: ModelExpirationBySymbolCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelExpirationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    expirationsByUnderlying(
      symbol: $symbol
      expirationId: $expirationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ttl
        symbol
        expiration
        expirationStyle
        settlementStyle
        strikes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOption = /* GraphQL */ `
  query GetOption(
    $id: ID!
    $underlying: String!
    $expiration: AWSDate!
    $cfi: String!
    $strike: String!
  ) {
    getOption(
      id: $id
      underlying: $underlying
      expiration: $expiration
      cfi: $cfi
      strike: $strike
    ) {
      id
      ttl
      underlying
      symbol
      country
      opol
      currency
      cfi
      multiplier
      spc
      mmy
      expiration
      lastTrade
      strike
      optionType
      expirationStyle
      settlementStyle
      priceIncrements
      tradingHours
      autocompleteWeight
      shortSaleRestriction
      tradingStatus
      statusReason
      haltStartTime
      haltEndTime
      high52WeekPrice
      low52WeekPrice
      highLimitPrice
      lowLimitPrice
      bidTime
      bidExchangeCode
      bidPrice
      bidSize
      askTime
      askExchangeCode
      askPrice
      askSize
      tradeTime
      tradeExchangeCode
      tradePrice
      tradeChange
      tradeSize
      tradeDayVolume
      tradeDayTurnover
      tradeTickTime
      extendedTradingHours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOptions = /* GraphQL */ `
  query ListOptions(
    $id: ID
    $underlyingExpirationCfiStrike: ModelOptionPrimaryCompositeKeyConditionInput
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOptions(
      id: $id
      underlyingExpirationCfiStrike: $underlyingExpirationCfiStrike
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        ttl
        underlying
        symbol
        country
        opol
        currency
        cfi
        multiplier
        spc
        mmy
        expiration
        lastTrade
        strike
        optionType
        expirationStyle
        settlementStyle
        priceIncrements
        tradingHours
        autocompleteWeight
        shortSaleRestriction
        tradingStatus
        statusReason
        haltStartTime
        haltEndTime
        high52WeekPrice
        low52WeekPrice
        highLimitPrice
        lowLimitPrice
        bidTime
        bidExchangeCode
        bidPrice
        bidSize
        askTime
        askExchangeCode
        askPrice
        askSize
        tradeTime
        tradeExchangeCode
        tradePrice
        tradeChange
        tradeSize
        tradeDayVolume
        tradeDayTurnover
        tradeTickTime
        extendedTradingHours
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const optionsByUnderlying = /* GraphQL */ `
  query OptionsByUnderlying(
    $underlying: String!
    $expirationCfiStrikeId: ModelOptionByUnderlyingCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionsByUnderlying(
      underlying: $underlying
      expirationCfiStrikeId: $expirationCfiStrikeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ttl
        underlying
        symbol
        country
        opol
        currency
        cfi
        multiplier
        spc
        mmy
        expiration
        lastTrade
        strike
        optionType
        expirationStyle
        settlementStyle
        priceIncrements
        tradingHours
        autocompleteWeight
        shortSaleRestriction
        tradingStatus
        statusReason
        haltStartTime
        haltEndTime
        high52WeekPrice
        low52WeekPrice
        highLimitPrice
        lowLimitPrice
        bidTime
        bidExchangeCode
        bidPrice
        bidSize
        askTime
        askExchangeCode
        askPrice
        askSize
        tradeTime
        tradeExchangeCode
        tradePrice
        tradeChange
        tradeSize
        tradeDayVolume
        tradeDayTurnover
        tradeTickTime
        extendedTradingHours
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const optionsBySymbol = /* GraphQL */ `
  query OptionsBySymbol(
    $symbol: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionsBySymbol(
      symbol: $symbol
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ttl
        underlying
        symbol
        country
        opol
        currency
        cfi
        multiplier
        spc
        mmy
        expiration
        lastTrade
        strike
        optionType
        expirationStyle
        settlementStyle
        priceIncrements
        tradingHours
        autocompleteWeight
        shortSaleRestriction
        tradingStatus
        statusReason
        haltStartTime
        haltEndTime
        high52WeekPrice
        low52WeekPrice
        highLimitPrice
        lowLimitPrice
        bidTime
        bidExchangeCode
        bidPrice
        bidSize
        askTime
        askExchangeCode
        askPrice
        askSize
        tradeTime
        tradeExchangeCode
        tradePrice
        tradeChange
        tradeSize
        tradeDayVolume
        tradeDayTurnover
        tradeTickTime
        extendedTradingHours
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActiveAsset = /* GraphQL */ `
  query GetActiveAsset($id: ID!) {
    getActiveAsset(id: $id) {
      id
      symbol
      underlying
      expiration
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listActiveAssets = /* GraphQL */ `
  query ListActiveAssets(
    $id: ID
    $filter: ModelActiveAssetFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listActiveAssets(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        symbol
        underlying
        expiration
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activeAssetsBySymbol = /* GraphQL */ `
  query ActiveAssetsBySymbol(
    $symbol: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActiveAssetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activeAssetsBySymbol(
      symbol: $symbol
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        symbol
        underlying
        expiration
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCryptoAsset = /* GraphQL */ `
  query GetCryptoAsset($id: ID!) {
    getCryptoAsset(id: $id) {
      id
      symbol
      updatedAt
      createdAt
      bid
      ask
      bidSize
      askSize
      __typename
    }
  }
`;
export const listCryptoAssets = /* GraphQL */ `
  query ListCryptoAssets(
    $id: ID
    $filter: ModelCryptoAssetFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCryptoAssets(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        symbol
        updatedAt
        createdAt
        bid
        ask
        bidSize
        askSize
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cryptoAssetsBySymbol = /* GraphQL */ `
  query CryptoAssetsBySymbol(
    $symbol: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCryptoAssetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cryptoAssetsBySymbol(
      symbol: $symbol
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        symbol
        updatedAt
        createdAt
        bid
        ask
        bidSize
        askSize
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNewsLetter = /* GraphQL */ `
  query GetNewsLetter($id: ID!) {
    getNewsLetter(id: $id) {
      id
      newsLetter
      portfolios
      subAccountNumbers
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNewsLetters = /* GraphQL */ `
  query ListNewsLetters(
    $id: ID
    $filter: ModelNewsLetterFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNewsLetters(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        newsLetter
        portfolios
        subAccountNumbers
        deleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsLetterByNewsLetter = /* GraphQL */ `
  query NewsLetterByNewsLetter(
    $newsLetter: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsLetterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsLetterByNewsLetter(
      newsLetter: $newsLetter
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        newsLetter
        portfolios
        subAccountNumbers
        deleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGroupUpload = /* GraphQL */ `
  query GetGroupUpload($id: ID!) {
    getGroupUpload(id: $id) {
      id
      name
      description
      orders {
        items {
          id
          groupUploadOrdersId
          accountNumber
          quantity
          brokerOverride
          commission
          owner
          userOrder {
            id
            accountNumber
            owner
            subAccountNumber
            cancel
            cancelReplace
            createdDate
            updatedDate
            commission
            feesAndCommission
            symbol
            side
            brokerSkipChecks
            brokerOverride
            brokerId
            quantity
            limitPrice
            stopPrice
            stockValue
            originalOrderId
            strategy
            avgPx
            orderType
            timeInForce
            instruction
            userOrderLegs {
              legType
              side
              quantity
              expiration
              strike
              openClose
              bid
              ask
              sharesPerContract
              avgPx
              __typename
            }
            cashSecured
            cashSecuredAmount
            message
            submitStatus
            status
            executionReports {
              items {
                id
                owner
                accountInformationId
                subAccountNumber
                orderID
                executionIncrementId
                secondaryOrderID
                clOrdID
                origClOrdID
                clientID
                execBroker
                listID
                execID
                execTransType
                execRefID
                execType
                ordStatus
                ordRejReason
                execRestatementReason
                account
                settlmntTyp
                futSettDate
                symbol
                symbolSfx
                securityID
                iDSource
                securityType
                maturityMonthYear
                maturityDay
                putOrCall
                strikePrice
                optAttribute
                contractMultiplier
                couponRate
                securityExchange
                issuer
                encodedIssuerLen
                encodedIssuer
                securityDesc
                encodedSecurityDescLen
                encodedSecurityDesc
                side
                orderQty
                cashOrderQty
                ordType
                price
                stopPx
                pegDifference
                discretionInst
                discretionOffset
                currency
                complianceID
                solicitedFlag
                timeInForce
                effectiveTime
                expireDate
                expireTime
                execInst
                rule80A
                lastShares
                lastPx
                lastSpotRate
                lastForwardPoints
                lastMkt
                tradingSessionID
                lastCapacity
                leavesQty
                cumQty
                avgPx
                dayOrderQty
                dayCumQty
                dayAvgPx
                gTBookingInst
                tradeDate
                transactTime
                reportToExch
                commission
                commType
                grossTradeAmt
                settlCurrAmt
                settlCurrency
                settlCurrFxRate
                settlCurrFxRateCalc
                handlInst
                minQty
                maxFloor
                openClose
                maxShow
                text
                encodedTextLen
                encodedText
                futSettDate2
                orderQty2
                clearingFirm
                clearingAccount
                multiLegReportingType
                legRefId
                uploadedToBackoffice
                fixMessage
                isAllocation
                groupUploadId
                processedAt
                createdDate
                createdAt
                updatedAt
                userOrderExecutionReportsId
                groupOrderExecutionReportsId
                __typename
              }
              nextToken
              __typename
            }
            cryptoOrder
            groupUploadOrderId
            reviewStatus
            createdAt
            updatedAt
            groupUpload {
              id
              name
              description
              orders {
                items {
                  id
                  groupUploadOrdersId
                  accountNumber
                  quantity
                  brokerOverride
                  commission
                  owner
                  userOrder {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  accountInformationId
                  failed
                  failedReason
                  orderIds
                  createdDate
                  createdAt
                  updatedAt
                  groupUploadOrderUserOrderId
                  __typename
                }
                nextToken
                __typename
              }
              owner
              isPlaced
              isPlacedString
              isAvgPx
              createdAt
              updatedAt
              __typename
            }
            accountInformationUserOrdersId
            userOrderGroupUploadId
            __typename
          }
          accountInformationId
          failed
          failedReason
          orderIds
          createdDate
          createdAt
          updatedAt
          groupUploadOrderUserOrderId
          __typename
        }
        nextToken
        __typename
      }
      owner
      isPlaced
      isPlacedString
      isAvgPx
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGroupUploads = /* GraphQL */ `
  query ListGroupUploads(
    $id: ID
    $filter: ModelGroupUploadFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroupUploads(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupUploadsByIsPlacedString = /* GraphQL */ `
  query GroupUploadsByIsPlacedString(
    $isPlacedString: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupUploadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupUploadsByIsPlacedString(
      isPlacedString: $isPlacedString
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupUploadByCreatedAt = /* GraphQL */ `
  query GroupUploadByCreatedAt(
    $createdAt: AWSDateTime!
    $sortDirection: ModelSortDirection
    $filter: ModelGroupUploadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupUploadByCreatedAt(
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGroupUploadOrder = /* GraphQL */ `
  query GetGroupUploadOrder($id: ID!) {
    getGroupUploadOrder(id: $id) {
      id
      groupUploadOrdersId
      accountNumber
      quantity
      brokerOverride
      commission
      owner
      userOrder {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      accountInformationId
      failed
      failedReason
      orderIds
      createdDate
      createdAt
      updatedAt
      groupUploadOrderUserOrderId
      __typename
    }
  }
`;
export const listGroupUploadOrders = /* GraphQL */ `
  query ListGroupUploadOrders(
    $id: ID
    $filter: ModelGroupUploadOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroupUploadOrders(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        groupUploadOrdersId
        accountNumber
        quantity
        brokerOverride
        commission
        owner
        userOrder {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        accountInformationId
        failed
        failedReason
        orderIds
        createdDate
        createdAt
        updatedAt
        groupUploadOrderUserOrderId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupUploadOrdersById = /* GraphQL */ `
  query GroupUploadOrdersById(
    $groupUploadOrdersId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGroupUploadOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupUploadOrdersById(
      groupUploadOrdersId: $groupUploadOrdersId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupUploadOrdersId
        accountNumber
        quantity
        brokerOverride
        commission
        owner
        userOrder {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        accountInformationId
        failed
        failedReason
        orderIds
        createdDate
        createdAt
        updatedAt
        groupUploadOrderUserOrderId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupUploadOrderByCreatedDate = /* GraphQL */ `
  query GroupUploadOrderByCreatedDate(
    $createdDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelGroupUploadOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupUploadOrderByCreatedDate(
      createdDate: $createdDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupUploadOrdersId
        accountNumber
        quantity
        brokerOverride
        commission
        owner
        userOrder {
          id
          accountNumber
          owner
          subAccountNumber
          cancel
          cancelReplace
          createdDate
          updatedDate
          commission
          feesAndCommission
          symbol
          side
          brokerSkipChecks
          brokerOverride
          brokerId
          quantity
          limitPrice
          stopPrice
          stockValue
          originalOrderId
          strategy
          avgPx
          orderType
          timeInForce
          instruction
          userOrderLegs {
            legType
            side
            quantity
            expiration
            strike
            openClose
            bid
            ask
            sharesPerContract
            avgPx
            __typename
          }
          cashSecured
          cashSecuredAmount
          message
          submitStatus
          status
          executionReports {
            items {
              id
              owner
              accountInformationId
              subAccountNumber
              orderID
              executionIncrementId
              secondaryOrderID
              clOrdID
              origClOrdID
              clientID
              execBroker
              listID
              execID
              execTransType
              execRefID
              execType
              ordStatus
              ordRejReason
              execRestatementReason
              account
              settlmntTyp
              futSettDate
              symbol
              symbolSfx
              securityID
              iDSource
              securityType
              maturityMonthYear
              maturityDay
              putOrCall
              strikePrice
              optAttribute
              contractMultiplier
              couponRate
              securityExchange
              issuer
              encodedIssuerLen
              encodedIssuer
              securityDesc
              encodedSecurityDescLen
              encodedSecurityDesc
              side
              orderQty
              cashOrderQty
              ordType
              price
              stopPx
              pegDifference
              discretionInst
              discretionOffset
              currency
              complianceID
              solicitedFlag
              timeInForce
              effectiveTime
              expireDate
              expireTime
              execInst
              rule80A
              lastShares
              lastPx
              lastSpotRate
              lastForwardPoints
              lastMkt
              tradingSessionID
              lastCapacity
              leavesQty
              cumQty
              avgPx
              dayOrderQty
              dayCumQty
              dayAvgPx
              gTBookingInst
              tradeDate
              transactTime
              reportToExch
              commission
              commType
              grossTradeAmt
              settlCurrAmt
              settlCurrency
              settlCurrFxRate
              settlCurrFxRateCalc
              handlInst
              minQty
              maxFloor
              openClose
              maxShow
              text
              encodedTextLen
              encodedText
              futSettDate2
              orderQty2
              clearingFirm
              clearingAccount
              multiLegReportingType
              legRefId
              uploadedToBackoffice
              fixMessage
              isAllocation
              groupUploadId
              processedAt
              createdDate
              createdAt
              updatedAt
              userOrderExecutionReportsId
              groupOrderExecutionReportsId
              __typename
            }
            nextToken
            __typename
          }
          cryptoOrder
          groupUploadOrderId
          reviewStatus
          createdAt
          updatedAt
          groupUpload {
            id
            name
            description
            orders {
              items {
                id
                groupUploadOrdersId
                accountNumber
                quantity
                brokerOverride
                commission
                owner
                userOrder {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                accountInformationId
                failed
                failedReason
                orderIds
                createdDate
                createdAt
                updatedAt
                groupUploadOrderUserOrderId
                __typename
              }
              nextToken
              __typename
            }
            owner
            isPlaced
            isPlacedString
            isAvgPx
            createdAt
            updatedAt
            __typename
          }
          accountInformationUserOrdersId
          userOrderGroupUploadId
          __typename
        }
        accountInformationId
        failed
        failedReason
        orderIds
        createdDate
        createdAt
        updatedAt
        groupUploadOrderUserOrderId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserOrder = /* GraphQL */ `
  query GetUserOrder($id: ID!) {
    getUserOrder(id: $id) {
      id
      accountNumber
      owner
      subAccountNumber
      cancel
      cancelReplace
      createdDate
      updatedDate
      commission
      feesAndCommission
      symbol
      side
      brokerSkipChecks
      brokerOverride
      brokerId
      quantity
      limitPrice
      stopPrice
      stockValue
      originalOrderId
      strategy
      avgPx
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      cashSecured
      cashSecuredAmount
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      groupUploadOrderId
      reviewStatus
      createdAt
      updatedAt
      groupUpload {
        id
        name
        description
        orders {
          items {
            id
            groupUploadOrdersId
            accountNumber
            quantity
            brokerOverride
            commission
            owner
            userOrder {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            accountInformationId
            failed
            failedReason
            orderIds
            createdDate
            createdAt
            updatedAt
            groupUploadOrderUserOrderId
            __typename
          }
          nextToken
          __typename
        }
        owner
        isPlaced
        isPlacedString
        isAvgPx
        createdAt
        updatedAt
        __typename
      }
      accountInformationUserOrdersId
      userOrderGroupUploadId
      __typename
    }
  }
`;
export const listUserOrders = /* GraphQL */ `
  query ListUserOrders(
    $id: ID
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserOrders(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByAccountNumber = /* GraphQL */ `
  query UserOrderByAccountNumber(
    $accountNumber: String!
    $symbol: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumber(
      accountNumber: $accountNumber
      symbol: $symbol
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByAccountNumberAndCreatedAt = /* GraphQL */ `
  query UserOrderByAccountNumberAndCreatedAt(
    $accountNumber: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumberAndCreatedAt(
      accountNumber: $accountNumber
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByAccountNumberAndStatus = /* GraphQL */ `
  query UserOrderByAccountNumberAndStatus(
    $accountNumber: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumberAndStatus(
      accountNumber: $accountNumber
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByAccountNumberAndUpdatedAt = /* GraphQL */ `
  query UserOrderByAccountNumberAndUpdatedAt(
    $accountNumber: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumberAndUpdatedAt(
      accountNumber: $accountNumber
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByAccountNumberAndUpdatedDate = /* GraphQL */ `
  query UserOrderByAccountNumberAndUpdatedDate(
    $accountNumber: String!
    $updatedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumberAndUpdatedDate(
      accountNumber: $accountNumber
      updatedDate: $updatedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderbySubAccountNumber = /* GraphQL */ `
  query UserOrderbySubAccountNumber(
    $subAccountNumber: String!
    $accountNumberId: ModelUserOrderBySubAccountNumberCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderbySubAccountNumber(
      subAccountNumber: $subAccountNumber
      accountNumberId: $accountNumberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByOriginalOrderId = /* GraphQL */ `
  query UserOrderByOriginalOrderId(
    $originalOrderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByOriginalOrderId(
      originalOrderId: $originalOrderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByStatus = /* GraphQL */ `
  query UserOrderByStatus(
    $status: OrderStatus!
    $symbol: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByStatus(
      status: $status
      symbol: $symbol
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByIsCryptoPosition = /* GraphQL */ `
  query UserOrderByIsCryptoPosition(
    $cryptoOrder: String!
    $accountNumberId: ModelUserOrderByIsCryptoPositionCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByIsCryptoPosition(
      cryptoOrder: $cryptoOrder
      accountNumberId: $accountNumberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrderByGroupUploadOrderId = /* GraphQL */ `
  query UserOrderByGroupUploadOrderId(
    $groupUploadOrderId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByGroupUploadOrderId(
      groupUploadOrderId: $groupUploadOrderId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        createdDate
        updatedDate
        commission
        feesAndCommission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        reviewStatus
        createdAt
        updatedAt
        groupUpload {
          id
          name
          description
          orders {
            items {
              id
              groupUploadOrdersId
              accountNumber
              quantity
              brokerOverride
              commission
              owner
              userOrder {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              accountInformationId
              failed
              failedReason
              orderIds
              createdDate
              createdAt
              updatedAt
              groupUploadOrderUserOrderId
              __typename
            }
            nextToken
            __typename
          }
          owner
          isPlaced
          isPlacedString
          isAvgPx
          createdAt
          updatedAt
          __typename
        }
        accountInformationUserOrdersId
        userOrderGroupUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      owner
      accountNumber
      subAccountNumber
      side
      accountInformationId
      orderIncrementId
      symbol
      feesAndCommission
      cancel
      cancelReplace
      quantity
      limitPrice
      stopPrice
      orderType
      timeInForce
      instruction
      originalOrderId
      orderStatus
      orderLeg {
        ratioQuantity
        legType
        side
        openClose
        expiration
        strike
        price
        __typename
      }
      userOrderId
      tradeAmount
      marginRequirement
      apexFdid
      apexCatAccountholderType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $id: ID
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrders(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        accountNumber
        subAccountNumber
        side
        accountInformationId
        orderIncrementId
        symbol
        feesAndCommission
        cancel
        cancelReplace
        quantity
        limitPrice
        stopPrice
        orderType
        timeInForce
        instruction
        originalOrderId
        orderStatus
        orderLeg {
          ratioQuantity
          legType
          side
          openClose
          expiration
          strike
          price
          __typename
        }
        userOrderId
        tradeAmount
        marginRequirement
        apexFdid
        apexCatAccountholderType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderOrderByAccountNumber = /* GraphQL */ `
  query OrderOrderByAccountNumber(
    $accountNumber: String!
    $symbol: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderOrderByAccountNumber(
      accountNumber: $accountNumber
      symbol: $symbol
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        accountNumber
        subAccountNumber
        side
        accountInformationId
        orderIncrementId
        symbol
        feesAndCommission
        cancel
        cancelReplace
        quantity
        limitPrice
        stopPrice
        orderType
        timeInForce
        instruction
        originalOrderId
        orderStatus
        orderLeg {
          ratioQuantity
          legType
          side
          openClose
          expiration
          strike
          price
          __typename
        }
        userOrderId
        tradeAmount
        marginRequirement
        apexFdid
        apexCatAccountholderType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderOrderByStatus = /* GraphQL */ `
  query OrderOrderByStatus(
    $orderStatus: OrderStatus!
    $orderIncrementId: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderOrderByStatus(
      orderStatus: $orderStatus
      orderIncrementId: $orderIncrementId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        accountNumber
        subAccountNumber
        side
        accountInformationId
        orderIncrementId
        symbol
        feesAndCommission
        cancel
        cancelReplace
        quantity
        limitPrice
        stopPrice
        orderType
        timeInForce
        instruction
        originalOrderId
        orderStatus
        orderLeg {
          ratioQuantity
          legType
          side
          openClose
          expiration
          strike
          price
          __typename
        }
        userOrderId
        tradeAmount
        marginRequirement
        apexFdid
        apexCatAccountholderType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExecutionReport = /* GraphQL */ `
  query GetExecutionReport($id: ID!) {
    getExecutionReport(id: $id) {
      id
      owner
      accountInformationId
      subAccountNumber
      orderID
      executionIncrementId
      secondaryOrderID
      clOrdID
      origClOrdID
      clientID
      execBroker
      listID
      execID
      execTransType
      execRefID
      execType
      ordStatus
      ordRejReason
      execRestatementReason
      account
      settlmntTyp
      futSettDate
      symbol
      symbolSfx
      securityID
      iDSource
      securityType
      maturityMonthYear
      maturityDay
      putOrCall
      strikePrice
      optAttribute
      contractMultiplier
      couponRate
      securityExchange
      issuer
      encodedIssuerLen
      encodedIssuer
      securityDesc
      encodedSecurityDescLen
      encodedSecurityDesc
      side
      orderQty
      cashOrderQty
      ordType
      price
      stopPx
      pegDifference
      discretionInst
      discretionOffset
      currency
      complianceID
      solicitedFlag
      timeInForce
      effectiveTime
      expireDate
      expireTime
      execInst
      rule80A
      lastShares
      lastPx
      lastSpotRate
      lastForwardPoints
      lastMkt
      tradingSessionID
      lastCapacity
      leavesQty
      cumQty
      avgPx
      dayOrderQty
      dayCumQty
      dayAvgPx
      gTBookingInst
      tradeDate
      transactTime
      reportToExch
      commission
      commType
      grossTradeAmt
      settlCurrAmt
      settlCurrency
      settlCurrFxRate
      settlCurrFxRateCalc
      handlInst
      minQty
      maxFloor
      openClose
      maxShow
      text
      encodedTextLen
      encodedText
      futSettDate2
      orderQty2
      clearingFirm
      clearingAccount
      multiLegReportingType
      legRefId
      uploadedToBackoffice
      fixMessage
      isAllocation
      groupUploadId
      processedAt
      createdDate
      createdAt
      updatedAt
      userOrderExecutionReportsId
      groupOrderExecutionReportsId
      __typename
    }
  }
`;
export const listExecutionReports = /* GraphQL */ `
  query ListExecutionReports(
    $id: ID
    $filter: ModelExecutionReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listExecutionReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        accountInformationId
        subAccountNumber
        orderID
        executionIncrementId
        secondaryOrderID
        clOrdID
        origClOrdID
        clientID
        execBroker
        listID
        execID
        execTransType
        execRefID
        execType
        ordStatus
        ordRejReason
        execRestatementReason
        account
        settlmntTyp
        futSettDate
        symbol
        symbolSfx
        securityID
        iDSource
        securityType
        maturityMonthYear
        maturityDay
        putOrCall
        strikePrice
        optAttribute
        contractMultiplier
        couponRate
        securityExchange
        issuer
        encodedIssuerLen
        encodedIssuer
        securityDesc
        encodedSecurityDescLen
        encodedSecurityDesc
        side
        orderQty
        cashOrderQty
        ordType
        price
        stopPx
        pegDifference
        discretionInst
        discretionOffset
        currency
        complianceID
        solicitedFlag
        timeInForce
        effectiveTime
        expireDate
        expireTime
        execInst
        rule80A
        lastShares
        lastPx
        lastSpotRate
        lastForwardPoints
        lastMkt
        tradingSessionID
        lastCapacity
        leavesQty
        cumQty
        avgPx
        dayOrderQty
        dayCumQty
        dayAvgPx
        gTBookingInst
        tradeDate
        transactTime
        reportToExch
        commission
        commType
        grossTradeAmt
        settlCurrAmt
        settlCurrency
        settlCurrFxRate
        settlCurrFxRateCalc
        handlInst
        minQty
        maxFloor
        openClose
        maxShow
        text
        encodedTextLen
        encodedText
        futSettDate2
        orderQty2
        clearingFirm
        clearingAccount
        multiLegReportingType
        legRefId
        uploadedToBackoffice
        fixMessage
        isAllocation
        groupUploadId
        processedAt
        createdDate
        createdAt
        updatedAt
        userOrderExecutionReportsId
        groupOrderExecutionReportsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const executionReportbySubAccountNumber = /* GraphQL */ `
  query ExecutionReportbySubAccountNumber(
    $subAccountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelExecutionReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    executionReportbySubAccountNumber(
      subAccountNumber: $subAccountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        accountInformationId
        subAccountNumber
        orderID
        executionIncrementId
        secondaryOrderID
        clOrdID
        origClOrdID
        clientID
        execBroker
        listID
        execID
        execTransType
        execRefID
        execType
        ordStatus
        ordRejReason
        execRestatementReason
        account
        settlmntTyp
        futSettDate
        symbol
        symbolSfx
        securityID
        iDSource
        securityType
        maturityMonthYear
        maturityDay
        putOrCall
        strikePrice
        optAttribute
        contractMultiplier
        couponRate
        securityExchange
        issuer
        encodedIssuerLen
        encodedIssuer
        securityDesc
        encodedSecurityDescLen
        encodedSecurityDesc
        side
        orderQty
        cashOrderQty
        ordType
        price
        stopPx
        pegDifference
        discretionInst
        discretionOffset
        currency
        complianceID
        solicitedFlag
        timeInForce
        effectiveTime
        expireDate
        expireTime
        execInst
        rule80A
        lastShares
        lastPx
        lastSpotRate
        lastForwardPoints
        lastMkt
        tradingSessionID
        lastCapacity
        leavesQty
        cumQty
        avgPx
        dayOrderQty
        dayCumQty
        dayAvgPx
        gTBookingInst
        tradeDate
        transactTime
        reportToExch
        commission
        commType
        grossTradeAmt
        settlCurrAmt
        settlCurrency
        settlCurrFxRate
        settlCurrFxRateCalc
        handlInst
        minQty
        maxFloor
        openClose
        maxShow
        text
        encodedTextLen
        encodedText
        futSettDate2
        orderQty2
        clearingFirm
        clearingAccount
        multiLegReportingType
        legRefId
        uploadedToBackoffice
        fixMessage
        isAllocation
        groupUploadId
        processedAt
        createdDate
        createdAt
        updatedAt
        userOrderExecutionReportsId
        groupOrderExecutionReportsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const executionReportByExecTransType = /* GraphQL */ `
  query ExecutionReportByExecTransType(
    $execTransType: String!
    $executionIncrementId: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelExecutionReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    executionReportByExecTransType(
      execTransType: $execTransType
      executionIncrementId: $executionIncrementId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        accountInformationId
        subAccountNumber
        orderID
        executionIncrementId
        secondaryOrderID
        clOrdID
        origClOrdID
        clientID
        execBroker
        listID
        execID
        execTransType
        execRefID
        execType
        ordStatus
        ordRejReason
        execRestatementReason
        account
        settlmntTyp
        futSettDate
        symbol
        symbolSfx
        securityID
        iDSource
        securityType
        maturityMonthYear
        maturityDay
        putOrCall
        strikePrice
        optAttribute
        contractMultiplier
        couponRate
        securityExchange
        issuer
        encodedIssuerLen
        encodedIssuer
        securityDesc
        encodedSecurityDescLen
        encodedSecurityDesc
        side
        orderQty
        cashOrderQty
        ordType
        price
        stopPx
        pegDifference
        discretionInst
        discretionOffset
        currency
        complianceID
        solicitedFlag
        timeInForce
        effectiveTime
        expireDate
        expireTime
        execInst
        rule80A
        lastShares
        lastPx
        lastSpotRate
        lastForwardPoints
        lastMkt
        tradingSessionID
        lastCapacity
        leavesQty
        cumQty
        avgPx
        dayOrderQty
        dayCumQty
        dayAvgPx
        gTBookingInst
        tradeDate
        transactTime
        reportToExch
        commission
        commType
        grossTradeAmt
        settlCurrAmt
        settlCurrency
        settlCurrFxRate
        settlCurrFxRateCalc
        handlInst
        minQty
        maxFloor
        openClose
        maxShow
        text
        encodedTextLen
        encodedText
        futSettDate2
        orderQty2
        clearingFirm
        clearingAccount
        multiLegReportingType
        legRefId
        uploadedToBackoffice
        fixMessage
        isAllocation
        groupUploadId
        processedAt
        createdDate
        createdAt
        updatedAt
        userOrderExecutionReportsId
        groupOrderExecutionReportsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const executionReportByCreatedDate = /* GraphQL */ `
  query ExecutionReportByCreatedDate(
    $createdDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelExecutionReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    executionReportByCreatedDate(
      createdDate: $createdDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        accountInformationId
        subAccountNumber
        orderID
        executionIncrementId
        secondaryOrderID
        clOrdID
        origClOrdID
        clientID
        execBroker
        listID
        execID
        execTransType
        execRefID
        execType
        ordStatus
        ordRejReason
        execRestatementReason
        account
        settlmntTyp
        futSettDate
        symbol
        symbolSfx
        securityID
        iDSource
        securityType
        maturityMonthYear
        maturityDay
        putOrCall
        strikePrice
        optAttribute
        contractMultiplier
        couponRate
        securityExchange
        issuer
        encodedIssuerLen
        encodedIssuer
        securityDesc
        encodedSecurityDescLen
        encodedSecurityDesc
        side
        orderQty
        cashOrderQty
        ordType
        price
        stopPx
        pegDifference
        discretionInst
        discretionOffset
        currency
        complianceID
        solicitedFlag
        timeInForce
        effectiveTime
        expireDate
        expireTime
        execInst
        rule80A
        lastShares
        lastPx
        lastSpotRate
        lastForwardPoints
        lastMkt
        tradingSessionID
        lastCapacity
        leavesQty
        cumQty
        avgPx
        dayOrderQty
        dayCumQty
        dayAvgPx
        gTBookingInst
        tradeDate
        transactTime
        reportToExch
        commission
        commType
        grossTradeAmt
        settlCurrAmt
        settlCurrency
        settlCurrFxRate
        settlCurrFxRateCalc
        handlInst
        minQty
        maxFloor
        openClose
        maxShow
        text
        encodedTextLen
        encodedText
        futSettDate2
        orderQty2
        clearingFirm
        clearingAccount
        multiLegReportingType
        legRefId
        uploadedToBackoffice
        fixMessage
        isAllocation
        groupUploadId
        processedAt
        createdDate
        createdAt
        updatedAt
        userOrderExecutionReportsId
        groupOrderExecutionReportsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGroupOrder = /* GraphQL */ `
  query GetGroupOrder($id: ID!) {
    getGroupOrder(id: $id) {
      id
      accountNumber
      allocation {
        subAccountNumber
        accountNumber
        allocation
        filledAllocation
        account_information_id
        user_profile_id
        balance_id
        sub_account_balance_id
        position_ids
        individualOrderStatus
        __typename
      }
      portfolio
      brokerSkipChecks
      brokerOverride
      newsLetter
      owner
      subAccountNumbers
      cancel
      cancelReplace
      commission
      symbol
      side
      quantity
      limitPrice
      stopPrice
      stockValue
      originalGroupOrderId
      originalOrderId
      strategy
      orderType
      timeInForce
      instruction
      userOrderLegs {
        legType
        side
        quantity
        expiration
        strike
        openClose
        bid
        ask
        sharesPerContract
        avgPx
        __typename
      }
      message
      submitStatus
      status
      executionReports {
        items {
          id
          owner
          accountInformationId
          subAccountNumber
          orderID
          executionIncrementId
          secondaryOrderID
          clOrdID
          origClOrdID
          clientID
          execBroker
          listID
          execID
          execTransType
          execRefID
          execType
          ordStatus
          ordRejReason
          execRestatementReason
          account
          settlmntTyp
          futSettDate
          symbol
          symbolSfx
          securityID
          iDSource
          securityType
          maturityMonthYear
          maturityDay
          putOrCall
          strikePrice
          optAttribute
          contractMultiplier
          couponRate
          securityExchange
          issuer
          encodedIssuerLen
          encodedIssuer
          securityDesc
          encodedSecurityDescLen
          encodedSecurityDesc
          side
          orderQty
          cashOrderQty
          ordType
          price
          stopPx
          pegDifference
          discretionInst
          discretionOffset
          currency
          complianceID
          solicitedFlag
          timeInForce
          effectiveTime
          expireDate
          expireTime
          execInst
          rule80A
          lastShares
          lastPx
          lastSpotRate
          lastForwardPoints
          lastMkt
          tradingSessionID
          lastCapacity
          leavesQty
          cumQty
          avgPx
          dayOrderQty
          dayCumQty
          dayAvgPx
          gTBookingInst
          tradeDate
          transactTime
          reportToExch
          commission
          commType
          grossTradeAmt
          settlCurrAmt
          settlCurrency
          settlCurrFxRate
          settlCurrFxRateCalc
          handlInst
          minQty
          maxFloor
          openClose
          maxShow
          text
          encodedTextLen
          encodedText
          futSettDate2
          orderQty2
          clearingFirm
          clearingAccount
          multiLegReportingType
          legRefId
          uploadedToBackoffice
          fixMessage
          isAllocation
          groupUploadId
          processedAt
          createdDate
          createdAt
          updatedAt
          userOrderExecutionReportsId
          groupOrderExecutionReportsId
          __typename
        }
        nextToken
        __typename
      }
      cryptoOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGroupOrders = /* GraphQL */ `
  query ListGroupOrders(
    $id: ID
    $filter: ModelGroupOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroupOrders(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        allocation {
          subAccountNumber
          accountNumber
          allocation
          filledAllocation
          account_information_id
          user_profile_id
          balance_id
          sub_account_balance_id
          position_ids
          individualOrderStatus
          __typename
        }
        portfolio
        brokerSkipChecks
        brokerOverride
        newsLetter
        owner
        subAccountNumbers
        cancel
        cancelReplace
        commission
        symbol
        side
        quantity
        limitPrice
        stopPrice
        stockValue
        originalGroupOrderId
        originalOrderId
        strategy
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupOrderByAccountNumber = /* GraphQL */ `
  query GroupOrderByAccountNumber(
    $accountNumber: String!
    $symbol: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupOrderByAccountNumber(
      accountNumber: $accountNumber
      symbol: $symbol
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        allocation {
          subAccountNumber
          accountNumber
          allocation
          filledAllocation
          account_information_id
          user_profile_id
          balance_id
          sub_account_balance_id
          position_ids
          individualOrderStatus
          __typename
        }
        portfolio
        brokerSkipChecks
        brokerOverride
        newsLetter
        owner
        subAccountNumbers
        cancel
        cancelReplace
        commission
        symbol
        side
        quantity
        limitPrice
        stopPrice
        stockValue
        originalGroupOrderId
        originalOrderId
        strategy
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupOrderByStatus = /* GraphQL */ `
  query GroupOrderByStatus(
    $status: OrderStatus!
    $symbol: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupOrderByStatus(
      status: $status
      symbol: $symbol
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        allocation {
          subAccountNumber
          accountNumber
          allocation
          filledAllocation
          account_information_id
          user_profile_id
          balance_id
          sub_account_balance_id
          position_ids
          individualOrderStatus
          __typename
        }
        portfolio
        brokerSkipChecks
        brokerOverride
        newsLetter
        owner
        subAccountNumbers
        cancel
        cancelReplace
        commission
        symbol
        side
        quantity
        limitPrice
        stopPrice
        stockValue
        originalGroupOrderId
        originalOrderId
        strategy
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupOrderByIsCryptoPosition = /* GraphQL */ `
  query GroupOrderByIsCryptoPosition(
    $cryptoOrder: String!
    $accountNumberId: ModelGroupOrderByIsCryptoPositionCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupOrderByIsCryptoPosition(
      cryptoOrder: $cryptoOrder
      accountNumberId: $accountNumberId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        allocation {
          subAccountNumber
          accountNumber
          allocation
          filledAllocation
          account_information_id
          user_profile_id
          balance_id
          sub_account_balance_id
          position_ids
          individualOrderStatus
          __typename
        }
        portfolio
        brokerSkipChecks
        brokerOverride
        newsLetter
        owner
        subAccountNumbers
        cancel
        cancelReplace
        commission
        symbol
        side
        quantity
        limitPrice
        stopPrice
        stockValue
        originalGroupOrderId
        originalOrderId
        strategy
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            isAllocation
            groupUploadId
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getApexInteractions = /* GraphQL */ `
  query GetApexInteractions($id: ID!) {
    getApexInteractions(id: $id) {
      id
      executionReportId
      accountNumber
      request
      response
      responseStatusCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listApexInteractions = /* GraphQL */ `
  query ListApexInteractions(
    $id: ID
    $filter: ModelApexInteractionsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listApexInteractions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        executionReportId
        accountNumber
        request
        response
        responseStatusCode
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMarginCallReport = /* GraphQL */ `
  query GetMarginCallReport($id: ID!) {
    getMarginCallReport(id: $id) {
      id
      callId
      accountNumber
      accountName
      callAmount
      callType
      tradeDate
      dueDate
      regTDate
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const listMarginCallReports = /* GraphQL */ `
  query ListMarginCallReports(
    $filter: ModelMarginCallReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMarginCallReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        callId
        accountNumber
        accountName
        callAmount
        callType
        tradeDate
        dueDate
        regTDate
        createdAt
        ttl
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const marginCallReportByAccountNumber = /* GraphQL */ `
  query MarginCallReportByAccountNumber(
    $accountNumber: String!
    $dueDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMarginCallReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    marginCallReportByAccountNumber(
      accountNumber: $accountNumber
      dueDate: $dueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        callId
        accountNumber
        accountName
        callAmount
        callType
        tradeDate
        dueDate
        regTDate
        createdAt
        ttl
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDailyExerciseAssignmentFile = /* GraphQL */ `
  query GetDailyExerciseAssignmentFile($id: ID!) {
    getDailyExerciseAssignmentFile(id: $id) {
      id
      processingStatus
      executionMethod
      optionSymbolKey
      optionQuantity
      stockIndexIndicator
      deliveryComponent
      optionSymbol
      underlyingSecurityInformation
      customerAccountNumberHoldingTheOption
      officeCode
      underlyingSymbol
      strikePrice
      payOutComponent
      notesField
      customerAccountNumberActivityToBeRunAgainst
      customerAccountType
      buySellCodeForUnderlying
      underlyingQuantity
      underlyingQuantityAdditional
      underLyingSymbolAssociatedWithTrade
      priceOfTrade
      tradeMarketCode
      tradeCapacityCode
      brokerInformation
      executionTimeTheTradeWillBeAssociatedWith
      commission
      tradeDate
      settlementDate
      excerciseAssignmentCode
      occClaimNumber
      accountType
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDailyExerciseAssignmentFiles = /* GraphQL */ `
  query ListDailyExerciseAssignmentFiles(
    $filter: ModelDailyExerciseAssignmentFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyExerciseAssignmentFiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        processingStatus
        executionMethod
        optionSymbolKey
        optionQuantity
        stockIndexIndicator
        deliveryComponent
        optionSymbol
        underlyingSecurityInformation
        customerAccountNumberHoldingTheOption
        officeCode
        underlyingSymbol
        strikePrice
        payOutComponent
        notesField
        customerAccountNumberActivityToBeRunAgainst
        customerAccountType
        buySellCodeForUnderlying
        underlyingQuantity
        underlyingQuantityAdditional
        underLyingSymbolAssociatedWithTrade
        priceOfTrade
        tradeMarketCode
        tradeCapacityCode
        brokerInformation
        executionTimeTheTradeWillBeAssociatedWith
        commission
        tradeDate
        settlementDate
        excerciseAssignmentCode
        occClaimNumber
        accountType
        ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNameBaseDump = /* GraphQL */ `
  query GetNameBaseDump($id: ID!) {
    getNameBaseDump(id: $id) {
      id
      accountNumber
      recordTypeCode
      recordTypeSubTypeCode
      rrIndexCode
      officeCode
      registeredRepCode
      federalIdIndicator
      taxIdNumber
      nameIndex
      shortName
      partyIndex
      relatedParty
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      irsControl
      multiRRS
      knd
      mapAccount
      fee
      mmSweep
      del
      pay
      div
      pri
      valCashPosition
      accountClass
      accountBalanceCategory
      printStatement
      fundPrincipal
      fundInterest
      discretion
      portfolioIndicator
      ira
      creditInterestSweep
      moneySweep
      optionLevel
      exposure
      nYTax
      stateTax
      iRSCode
      fedTypeCode
      nonObjecting
      iRSExempt
      foreignCode
      mature
      fundFees
      optionLimit
      forwardLimit
      suppressConfirm
      restrictReasonCode
      commissionSchedule
      w8
      fundDividend
      fundMature
      joint
      legal
      margin
      optionCode
      corpRes
      loan
      nPLoan
      commodites
      powerAttorney
      intFutures
      curFutures
      segCode
      pubEntity
      tradeAuthorize
      tradeAccountAuthorize
      forwardDel
      repo
      customer
      riskDisclose
      nonCashDisclose
      hedgeLetter
      unsolicited
      partnership
      soleOwner
      fedFunds
      safeKeeping
      ach
      mas
      dvp
      disclosureStatement
      sweep
      fundRateClass
      sicCode
      userCode1
      userCode2
      userCode3
      userCode4
      userCode5
      userCode6
      instituion
      agentBank
      customerAccount
      abaNumber
      alternateAccountTypeA
      abaNumberB
      alternateAccountTypeB
      telcoExtension1
      telcoExtension2
      restrDate
      openDDate
      lastChangeDate
      lastActivtyDate
      lastTradeDate
      stockBorrowLoan
      inventoryCarryType
      numberId
      addressIndicator
      telcoCode1
      telcoCode2
      telcoAreaCode1
      telcoExchange1
      telcoBase1
      telcoAreaCode2
      telcoExchange2
      telcoBase2
      dayTradeCounter
      oldSystemAccountNumber
      alternateAccountB
      alternateAccountA
      closedDate
      preEffAYY
      preEffBYY
      tefraChangeYY
      bankFailReport
      issuerStatus
      aRBCode
      processDate
      accountNature
      fdid
      mpid
      cATAccountType
      oATSAccountType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNameBaseDumps = /* GraphQL */ `
  query ListNameBaseDumps(
    $filter: ModelNameBaseDumpFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNameBaseDumps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountNumber
        recordTypeCode
        recordTypeSubTypeCode
        rrIndexCode
        officeCode
        registeredRepCode
        federalIdIndicator
        taxIdNumber
        nameIndex
        shortName
        partyIndex
        relatedParty
        accountName
        addressLine1
        addressLine2
        addressLine3
        addressLine4
        city
        state
        zipCode
        irsControl
        multiRRS
        knd
        mapAccount
        fee
        mmSweep
        del
        pay
        div
        pri
        valCashPosition
        accountClass
        accountBalanceCategory
        printStatement
        fundPrincipal
        fundInterest
        discretion
        portfolioIndicator
        ira
        creditInterestSweep
        moneySweep
        optionLevel
        exposure
        nYTax
        stateTax
        iRSCode
        fedTypeCode
        nonObjecting
        iRSExempt
        foreignCode
        mature
        fundFees
        optionLimit
        forwardLimit
        suppressConfirm
        restrictReasonCode
        commissionSchedule
        w8
        fundDividend
        fundMature
        joint
        legal
        margin
        optionCode
        corpRes
        loan
        nPLoan
        commodites
        powerAttorney
        intFutures
        curFutures
        segCode
        pubEntity
        tradeAuthorize
        tradeAccountAuthorize
        forwardDel
        repo
        customer
        riskDisclose
        nonCashDisclose
        hedgeLetter
        unsolicited
        partnership
        soleOwner
        fedFunds
        safeKeeping
        ach
        mas
        dvp
        disclosureStatement
        sweep
        fundRateClass
        sicCode
        userCode1
        userCode2
        userCode3
        userCode4
        userCode5
        userCode6
        instituion
        agentBank
        customerAccount
        abaNumber
        alternateAccountTypeA
        abaNumberB
        alternateAccountTypeB
        telcoExtension1
        telcoExtension2
        restrDate
        openDDate
        lastChangeDate
        lastActivtyDate
        lastTradeDate
        stockBorrowLoan
        inventoryCarryType
        numberId
        addressIndicator
        telcoCode1
        telcoCode2
        telcoAreaCode1
        telcoExchange1
        telcoBase1
        telcoAreaCode2
        telcoExchange2
        telcoBase2
        dayTradeCounter
        oldSystemAccountNumber
        alternateAccountB
        alternateAccountA
        closedDate
        preEffAYY
        preEffBYY
        tefraChangeYY
        bankFailReport
        issuerStatus
        aRBCode
        processDate
        accountNature
        fdid
        mpid
        cATAccountType
        oATSAccountType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConsolidatedCashActivityReport = /* GraphQL */ `
  query GetConsolidatedCashActivityReport($id: ID!) {
    getConsolidatedCashActivityReport(id: $id) {
      id
      accountNumber
      accountType
      amount
      description
      currencyCode
      processDate
      batchCode
      cusip
      entryDate
      sourceProgram
      userId
      activityIndicator
      officeCode
      acatsControlNumber
      actionCode
      checkNumber
      contraAccountNumber
      contraAccountTypeCode
      contraCurrencyCode
      corrWindowCode
      currentPaydownFactor
      divTaxTypeCode
      dTCNumber
      dTCNumberExp
      effectiveDate
      enteredBy
      entryTypeCode
      feeIndicator
      firm
      foreignCode
      fundsUserCode
      gLPostStatusCode
      historyEntryCode
      interestEffectiveDate
      lastPaydownFactor
      mDHIndicator
      mergeEntryCode
      mAgentIndicator
      moneyMarketCode
      mutualFundPostIndicator
      originalQuantity
      overrideIndicator
      pasMergeEntryCode
      payTypeCode
      price
      recTypeCode
      registeredRepCode
      rRCategoryCode
      sequenceNumber
      smaChangeAmount
      statementIndicator
      statusCode
      taxOverrideCode
      taxYear
      terminalId
      thirdPartyCode
      tradeDate
      tradenumber
      userEntryDate
      wireFundsCode
      withholdTaxIndicator
      withholdTaxTypeCode
      correspondentOfficeId
      correspondentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listConsolidatedCashActivityReports = /* GraphQL */ `
  query ListConsolidatedCashActivityReports(
    $filter: ModelConsolidatedCashActivityReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConsolidatedCashActivityReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        accountType
        amount
        description
        currencyCode
        processDate
        batchCode
        cusip
        entryDate
        sourceProgram
        userId
        activityIndicator
        officeCode
        acatsControlNumber
        actionCode
        checkNumber
        contraAccountNumber
        contraAccountTypeCode
        contraCurrencyCode
        corrWindowCode
        currentPaydownFactor
        divTaxTypeCode
        dTCNumber
        dTCNumberExp
        effectiveDate
        enteredBy
        entryTypeCode
        feeIndicator
        firm
        foreignCode
        fundsUserCode
        gLPostStatusCode
        historyEntryCode
        interestEffectiveDate
        lastPaydownFactor
        mDHIndicator
        mergeEntryCode
        mAgentIndicator
        moneyMarketCode
        mutualFundPostIndicator
        originalQuantity
        overrideIndicator
        pasMergeEntryCode
        payTypeCode
        price
        recTypeCode
        registeredRepCode
        rRCategoryCode
        sequenceNumber
        smaChangeAmount
        statementIndicator
        statusCode
        taxOverrideCode
        taxYear
        terminalId
        thirdPartyCode
        tradeDate
        tradenumber
        userEntryDate
        wireFundsCode
        withholdTaxIndicator
        withholdTaxTypeCode
        correspondentOfficeId
        correspondentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTradeActivity = /* GraphQL */ `
  query GetTradeActivity($id: ID!) {
    getTradeActivity(id: $id) {
      id
      accountNumber
      processDate
      firm
      correspondentId
      correspondentOfficeId
      correspondentCode
      officeCode
      registeredRepCode
      accountType
      buySellcode
      tradeDate
      tradeNumber
      executionTime
      cusip
      symbol
      quantity
      price
      marketCode
      capacityCode
      commissionGrossCalculated
      commissionGrossEntered
      settlementDate
      currencyCode
      prncipalAmount
      netAmount
      feeSec
      feeMisc
      fee1
      fee2
      fee3
      fee4
      fee5
      entryDate
      shortDescription
      trailerCode
      tradeInterest
      executingBrokerBack
      securityTypeCode
      commissionRRCategory
      reallowance
      commissionEntered
      shortName
      factor
      commissionNet
      trailer
      executingBrokerFront
      feeMF
      clearingSymbol
      repo
      description1
      securitySubType
      instructionsTradeLegendCode
      country
      isin
      languageId
      instructionsSpecial1
      instructionsSpecial2
      originalTradeNumber
      tradeLegendCode
      optionSymbolRoot
      displaySymbol
      strikePrice
      callPut
      expirationDeliveryDate
      optionContractDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTradeActivities = /* GraphQL */ `
  query ListTradeActivities(
    $filter: ModelTradeActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTradeActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountNumber
        processDate
        firm
        correspondentId
        correspondentOfficeId
        correspondentCode
        officeCode
        registeredRepCode
        accountType
        buySellcode
        tradeDate
        tradeNumber
        executionTime
        cusip
        symbol
        quantity
        price
        marketCode
        capacityCode
        commissionGrossCalculated
        commissionGrossEntered
        settlementDate
        currencyCode
        prncipalAmount
        netAmount
        feeSec
        feeMisc
        fee1
        fee2
        fee3
        fee4
        fee5
        entryDate
        shortDescription
        trailerCode
        tradeInterest
        executingBrokerBack
        securityTypeCode
        commissionRRCategory
        reallowance
        commissionEntered
        shortName
        factor
        commissionNet
        trailer
        executingBrokerFront
        feeMF
        clearingSymbol
        repo
        description1
        securitySubType
        instructionsTradeLegendCode
        country
        isin
        languageId
        instructionsSpecial1
        instructionsSpecial2
        originalTradeNumber
        tradeLegendCode
        optionSymbolRoot
        displaySymbol
        strikePrice
        callPut
        expirationDeliveryDate
        optionContractDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOvernightBuyingPower = /* GraphQL */ `
  query GetOvernightBuyingPower($id: ID!) {
    getOvernightBuyingPower(id: $id) {
      id
      overnightBuyingPowerId
      accountNumber
      firm
      officeCode
      correspondentCode
      processDate
      currencyCode
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      marginRequirementWithConcentration
      marginExcessEquityWithConcentration
      overnightBuyingPowerCalculated
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerCalculated
      regTBuyingPowerIssued
      overnightFactorCalculated
      overnightFactorIssued
      dayTradeFactorCalculated
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      moneyMarketTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      freeCash
      sma
      availableToWithdraw
      futureBalance
      futureEquity
      futureRequirement
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      highWaterMark
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOvernightBuyingPowers = /* GraphQL */ `
  query ListOvernightBuyingPowers(
    $filter: ModelOvernightBuyingPowerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOvernightBuyingPowers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        overnightBuyingPowerId
        accountNumber
        firm
        officeCode
        correspondentCode
        processDate
        currencyCode
        totalEquity
        marginEquity
        marginRequirement
        marginExcessEquity
        cashEquity
        cashRequirement
        cashExcessEquity
        marginRequirementWithConcentration
        marginExcessEquityWithConcentration
        overnightBuyingPowerCalculated
        overnightBuyingPowerIssued
        dayTradeBuyingPowerIssued
        regTBuyingPowerCalculated
        regTBuyingPowerIssued
        overnightFactorCalculated
        overnightFactorIssued
        dayTradeFactorCalculated
        dayTradeFactorIssued
        marginEquityPercent
        positionMarketValue
        longEquityMarketValue
        shortEquityMarketValue
        longOptionMarketValue
        shortOptionMarketValue
        totalTradeBalance
        totalSettleBalance
        cashTradeBalance
        marginTradeBalance
        shortTradeBalance
        moneyMarketTradeBalance
        cashSettleBalance
        marginSettleBalance
        shortSettleBalance
        moneyMarketSettleBalance
        freeCash
        sma
        availableToWithdraw
        futureBalance
        futureEquity
        futureRequirement
        optionsRequirement
        nonOptionsRequirement
        lastUpdate
        nonOptionsRequirementNotConcentrated
        typeIUnavailableCashProceeds
        typeIIUnavailableCashProceeds
        netBalance
        smaCommitted
        highWaterMark
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPositionBreakout = /* GraphQL */ `
  query GetPositionBreakout($id: ID!) {
    getPositionBreakout(id: $id) {
      id
      ttl
      accountNumber
      firm
      officeCode
      strategyId
      strategySequence
      accountType
      cusip
      tradeQuantity
      symbol
      description
      closingPrice
      marketValue
      securityTypeCode
      underlyingSymbol
      strikePrice
      isin
      change
      positionType
      processDate
      isSelling
      maintenanceRequirement
      concentrationRequirement
      optionStrategy
      optionLeg
      strategyMaintenanceRequirement
      strategyConcentrationRequirement
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPositionBreakouts = /* GraphQL */ `
  query ListPositionBreakouts(
    $filter: ModelPositionBreakoutFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPositionBreakouts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ttl
        accountNumber
        firm
        officeCode
        strategyId
        strategySequence
        accountType
        cusip
        tradeQuantity
        symbol
        description
        closingPrice
        marketValue
        securityTypeCode
        underlyingSymbol
        strikePrice
        isin
        change
        positionType
        processDate
        isSelling
        maintenanceRequirement
        concentrationRequirement
        optionStrategy
        optionLeg
        strategyMaintenanceRequirement
        strategyConcentrationRequirement
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDailyPostmaster = /* GraphQL */ `
  query GetDailyPostmaster($id: ID!) {
    getDailyPostmaster(id: $id) {
      id
      firm
      accountNumber
      mailTypeId
      mailTypeDescription
      processDate
      correspondentCode
      officeCode
      accountName
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDailyPostmasters = /* GraphQL */ `
  query ListDailyPostmasters(
    $filter: ModelDailyPostmasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyPostmasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firm
        accountNumber
        mailTypeId
        mailTypeDescription
        processDate
        correspondentCode
        officeCode
        accountName
        addressLine1
        addressLine2
        addressLine3
        addressLine4
        city
        state
        zipCode
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getElectronicCommunication = /* GraphQL */ `
  query GetElectronicCommunication($id: ID!) {
    getElectronicCommunication(id: $id) {
      id
      accountNumber
      registeredRepCode
      statementStatus
      confirmStatus
      prospectusStatus
      proxyStatus
      taxStatus
      closedIndicator
      closedReason
      emailAddress
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listElectronicCommunications = /* GraphQL */ `
  query ListElectronicCommunications(
    $filter: ModelElectronicCommunicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listElectronicCommunications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        registeredRepCode
        statementStatus
        confirmStatus
        prospectusStatus
        proxyStatus
        taxStatus
        closedIndicator
        closedReason
        emailAddress
        lastUpdated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPositionHistory = /* GraphQL */ `
  query GetPositionHistory($id: ID!) {
    getPositionHistory(id: $id) {
      id
      recordNumber
      clientNumber
      correspondentCode
      accountNumber
      currency
      trid
      sequenceNumber
      cusip
      securityType
      symbolMsd
      numberMsd
      taxLotOpenBuyDate
      taxLotCloseSellDate
      settlementDate
      quantity
      cost
      netProceed
      realizedGainLoss
      longTermShortTermIndicator
      realizedIndicator
      zeroIndicator
      lmBuyDateIndicator
      lmCostDateIndicator
      lmMarketValueIndicator
      lmGainLossIndicator
      securityNumberMsd
      descriptionNumber
      description1
      description2
      description3
      openBuyPrice
      openBuyCostAmount
      openLotID
      closedLotID
      washSalesIndicator
      buyBackIndicator
      openTransactionID
      closedTransactionID
      giftIndicator
      inheritanceIndicator
      washSaleAdjustmentDate
      coveredIndicator
      washSalesDisAllowed
      costMethod
      washSaleAdjustmentAmount
      costPerShare
      unadjustedAmount
      principleAmount
      principleCommissionFee
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPositionHistories = /* GraphQL */ `
  query ListPositionHistories(
    $filter: ModelPositionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPositionHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recordNumber
        clientNumber
        correspondentCode
        accountNumber
        currency
        trid
        sequenceNumber
        cusip
        securityType
        symbolMsd
        numberMsd
        taxLotOpenBuyDate
        taxLotCloseSellDate
        settlementDate
        quantity
        cost
        netProceed
        realizedGainLoss
        longTermShortTermIndicator
        realizedIndicator
        zeroIndicator
        lmBuyDateIndicator
        lmCostDateIndicator
        lmMarketValueIndicator
        lmGainLossIndicator
        securityNumberMsd
        descriptionNumber
        description1
        description2
        description3
        openBuyPrice
        openBuyCostAmount
        openLotID
        closedLotID
        washSalesIndicator
        buyBackIndicator
        openTransactionID
        closedTransactionID
        giftIndicator
        inheritanceIndicator
        washSaleAdjustmentDate
        coveredIndicator
        washSalesDisAllowed
        costMethod
        washSaleAdjustmentAmount
        costPerShare
        unadjustedAmount
        principleAmount
        principleCommissionFee
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const positionHistoryByAccountNumber = /* GraphQL */ `
  query PositionHistoryByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPositionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    positionHistoryByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recordNumber
        clientNumber
        correspondentCode
        accountNumber
        currency
        trid
        sequenceNumber
        cusip
        securityType
        symbolMsd
        numberMsd
        taxLotOpenBuyDate
        taxLotCloseSellDate
        settlementDate
        quantity
        cost
        netProceed
        realizedGainLoss
        longTermShortTermIndicator
        realizedIndicator
        zeroIndicator
        lmBuyDateIndicator
        lmCostDateIndicator
        lmMarketValueIndicator
        lmGainLossIndicator
        securityNumberMsd
        descriptionNumber
        description1
        description2
        description3
        openBuyPrice
        openBuyCostAmount
        openLotID
        closedLotID
        washSalesIndicator
        buyBackIndicator
        openTransactionID
        closedTransactionID
        giftIndicator
        inheritanceIndicator
        washSaleAdjustmentDate
        coveredIndicator
        washSalesDisAllowed
        costMethod
        washSaleAdjustmentAmount
        costPerShare
        unadjustedAmount
        principleAmount
        principleCommissionFee
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSystemConfig = /* GraphQL */ `
  query GetSystemConfig($id: ID!) {
    getSystemConfig(id: $id) {
      id
      globalTrading
      optionsTrading
      equityTrading
      cryptoTrading
      margin
      lastExecutionProcessed
      lastOrderProcessed
      eventsWatermarks
      symbolTradeRestrictions {
        id
        symbol
        restrictionType
        createdAt
        updatedAt
        __typename
      }
      systemNotification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSystemConfigs = /* GraphQL */ `
  query ListSystemConfigs(
    $id: ID
    $filter: ModelSystemConfigFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSystemConfigs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        globalTrading
        optionsTrading
        equityTrading
        cryptoTrading
        margin
        lastExecutionProcessed
        lastOrderProcessed
        eventsWatermarks
        symbolTradeRestrictions {
          id
          symbol
          restrictionType
          createdAt
          updatedAt
          __typename
        }
        systemNotification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSymbolTradeRestrictions = /* GraphQL */ `
  query GetSymbolTradeRestrictions($id: ID!) {
    getSymbolTradeRestrictions(id: $id) {
      id
      symbol
      restrictionType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSymbolTradeRestrictions = /* GraphQL */ `
  query ListSymbolTradeRestrictions(
    $id: ID
    $filter: ModelSymbolTradeRestrictionsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSymbolTradeRestrictions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        symbol
        restrictionType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommissionSchedule = /* GraphQL */ `
  query GetCommissionSchedule($id: ID!) {
    getCommissionSchedule(id: $id) {
      commissionCode
      security
      method
      commissionPerUnit
      minCharge
      ticketCharge
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCommissionSchedules = /* GraphQL */ `
  query ListCommissionSchedules(
    $filter: ModelCommissionScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommissionSchedules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        commissionCode
        security
        method
        commissionPerUnit
        minCharge
        ticketCharge
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      cognitoId
      owner
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      updatedBy
      sendToApex
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $id: ID
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserProfiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        cognitoId
        owner
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        updatedBy
        sendToApex
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userProfileByOwner = /* GraphQL */ `
  query UserProfileByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userProfileByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        owner
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        updatedBy
        sendToApex
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userProfileByMemberStatus = /* GraphQL */ `
  query UserProfileByMemberStatus(
    $memberStatus: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userProfileByMemberStatus(
      memberStatus: $memberStatus
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        owner
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        updatedBy
        sendToApex
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userProfileBySocialSecurityNumber = /* GraphQL */ `
  query UserProfileBySocialSecurityNumber(
    $socialSecurityNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userProfileBySocialSecurityNumber(
      socialSecurityNumber: $socialSecurityNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        owner
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        updatedBy
        sendToApex
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUserProfiles = /* GraphQL */ `
  query SearchUserProfiles(
    $filter: SearchableUserProfileFilterInput
    $sort: [SearchableUserProfileSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserProfileAggregationInput]
  ) {
    searchUserProfiles(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        cognitoId
        owner
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        updatedBy
        sendToApex
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getProfilePicture = /* GraphQL */ `
  query GetProfilePicture($id: ID!) {
    getProfilePicture(id: $id) {
      id
      owner
      profilePicture
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProfilePictures = /* GraphQL */ `
  query ListProfilePictures(
    $id: ID
    $filter: ModelProfilePictureFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProfilePictures(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const profilePictureByOwner = /* GraphQL */ `
  query ProfilePictureByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProfilePictureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    profilePictureByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDraftUserProfile = /* GraphQL */ `
  query GetDraftUserProfile($id: ID!) {
    getDraftUserProfile(id: $id) {
      id
      cognitoId
      owner
      userAccountType
      memberStatus
      memberDate
      lastChargeDate
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      email
      familyName
      phoneNumber
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      trustedContact {
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        address {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
      profilePicture {
        id
        owner
        profilePicture
        createdAt
        updatedAt
        __typename
      }
      dateOfBirth
      socialSecurityNumber
      citizenshipCountry
      catAccountholderType
      customerType
      accountType
      politicallyExposed {
        politicalOrganization
        immediateFamily
        __typename
      }
      controlPersonSymbols
      affiliated {
        firmName
        affiliatedApproval
        docS3Key
        __typename
      }
      customerAccountAgreement
      privacyPolicy
      accounts {
        items {
          id
          primaryOwner
          owner
          accountNumber
          accountName
          accountType
          customerType
          accountRequestStatus
          investigationStatus
          apexId
          apexFdid
          apexCatAccountholderType
          apexJson
          accountStatus
          balance {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            overnightBuyingPowerID
            firm
            totalEquity
            marginEquity
            marginRequirement
            marginExcessEquity
            cashEquity
            cashRequirement
            cashExcessEquity
            overnightBuyingPowerIssued
            dayTradeBuyingPowerIssued
            regTBuyingPowerIssued
            overnightFactorIssued
            dayTradeFactorIssued
            marginEquityPercent
            positionMarketValue
            longEquityMarketValue
            shortEquityMarketValue
            longOptionMarketValue
            shortOptionMarketValue
            totalTradeBalance
            totalSettleBalance
            cashTradeBalance
            marginTradeBalance
            shortTradeBalance
            cashSettleBalance
            marginSettleBalance
            shortSettleBalance
            moneyMarketSettleBalance
            moneyMarketTradeBalance
            freeCash
            sma
            availableToWithdraw
            optionsRequirement
            nonOptionsRequirement
            lastUpdate
            nonOptionsRequirementNotConcentrated
            typeIUnavailableCashProceeds
            typeIIUnavailableCashProceeds
            netBalance
            smaCommitted
            netLiquidity
            pendingDebitInterest
            pendingDebitDividends
            fullyPaidUnsettledFunds
            cashOnOrders
            buyingPowerOnOrders
            marginExcessEquitySod
            cashExcessEquitySod
            netBalanceSod
            optionBuyingPowerInternal
            stockBuyingPowerInternal
            updateFlag
            accountType
            pendingTransfers {
              deposit
              amount
              achDepositWithdrawalRequestId
              __typename
            }
            createdAt
            updatedAt
            balanceAccountInformationId
            __typename
          }
          permissions {
            id
            accountNumber
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            owner
            systemAccess
            equityTrading
            optionsTrading
            cryptoTrading
            margin
            securitiesLending
            optionsLevel
            exitOnlyTrades
            restrictReason
            allowCancelOrder
            allowModifyOrder
            achWithdrawal
            patternDayTrader
            achApproval
            profileStatus
            betaFeatures
            achDeposit
            updatedBy
            createdAt
            updatedAt
            userPermissionsAccountInformationId
            __typename
          }
          userOrders {
            items {
              id
              accountNumber
              owner
              subAccountNumber
              cancel
              cancelReplace
              createdDate
              updatedDate
              commission
              feesAndCommission
              symbol
              side
              brokerSkipChecks
              brokerOverride
              brokerId
              quantity
              limitPrice
              stopPrice
              stockValue
              originalOrderId
              strategy
              avgPx
              orderType
              timeInForce
              instruction
              userOrderLegs {
                legType
                side
                quantity
                expiration
                strike
                openClose
                bid
                ask
                sharesPerContract
                avgPx
                __typename
              }
              cashSecured
              cashSecuredAmount
              message
              submitStatus
              status
              executionReports {
                items {
                  id
                  owner
                  accountInformationId
                  subAccountNumber
                  orderID
                  executionIncrementId
                  secondaryOrderID
                  clOrdID
                  origClOrdID
                  clientID
                  execBroker
                  listID
                  execID
                  execTransType
                  execRefID
                  execType
                  ordStatus
                  ordRejReason
                  execRestatementReason
                  account
                  settlmntTyp
                  futSettDate
                  symbol
                  symbolSfx
                  securityID
                  iDSource
                  securityType
                  maturityMonthYear
                  maturityDay
                  putOrCall
                  strikePrice
                  optAttribute
                  contractMultiplier
                  couponRate
                  securityExchange
                  issuer
                  encodedIssuerLen
                  encodedIssuer
                  securityDesc
                  encodedSecurityDescLen
                  encodedSecurityDesc
                  side
                  orderQty
                  cashOrderQty
                  ordType
                  price
                  stopPx
                  pegDifference
                  discretionInst
                  discretionOffset
                  currency
                  complianceID
                  solicitedFlag
                  timeInForce
                  effectiveTime
                  expireDate
                  expireTime
                  execInst
                  rule80A
                  lastShares
                  lastPx
                  lastSpotRate
                  lastForwardPoints
                  lastMkt
                  tradingSessionID
                  lastCapacity
                  leavesQty
                  cumQty
                  avgPx
                  dayOrderQty
                  dayCumQty
                  dayAvgPx
                  gTBookingInst
                  tradeDate
                  transactTime
                  reportToExch
                  commission
                  commType
                  grossTradeAmt
                  settlCurrAmt
                  settlCurrency
                  settlCurrFxRate
                  settlCurrFxRateCalc
                  handlInst
                  minQty
                  maxFloor
                  openClose
                  maxShow
                  text
                  encodedTextLen
                  encodedText
                  futSettDate2
                  orderQty2
                  clearingFirm
                  clearingAccount
                  multiLegReportingType
                  legRefId
                  uploadedToBackoffice
                  fixMessage
                  isAllocation
                  groupUploadId
                  processedAt
                  createdDate
                  createdAt
                  updatedAt
                  userOrderExecutionReportsId
                  groupOrderExecutionReportsId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoOrder
              groupUploadOrderId
              reviewStatus
              createdAt
              updatedAt
              groupUpload {
                id
                name
                description
                orders {
                  items {
                    id
                    groupUploadOrdersId
                    accountNumber
                    quantity
                    brokerOverride
                    commission
                    owner
                    accountInformationId
                    failed
                    failedReason
                    orderIds
                    createdDate
                    createdAt
                    updatedAt
                    groupUploadOrderUserOrderId
                    __typename
                  }
                  nextToken
                  __typename
                }
                owner
                isPlaced
                isPlacedString
                isAvgPx
                createdAt
                updatedAt
                __typename
              }
              accountInformationUserOrdersId
              userOrderGroupUploadId
              __typename
            }
            nextToken
            __typename
          }
          positions {
            items {
              id
              accountNumber
              owner
              underlying
              pricePaid
              isCryptoPosition
              quantity
              marginRequirement
              strategy
              positionLegs {
                side
                quantity
                ratioQuantity
                pricePaid
                legType
                cusip
                marginRequirement
                expiration
                strike
                __typename
              }
              subAccountNumber
              status
              groupUploadOrderId
              createdAt
              updatedAt
              accountInformationPositionsId
              __typename
            }
            nextToken
            __typename
          }
          subAccounts {
            items {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              selfDirected
              balance {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                accountType
                createdAt
                updatedAt
                __typename
              }
              transfers {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  toSubAccountNumber
                  amount
                  message
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  subAccountTransfersId
                  __typename
                }
                nextToken
                __typename
              }
              commissionCode
              repCode
              newsLetter {
                newsLetter
                portfolio
                __typename
              }
              stock {
                stockSignals
                maxDollarAllocationPerSignal
                maxNumberOfSharesPerSignal
                allOrNone
                roundLotsOnly
                multiplier
                __typename
              }
              option {
                optionSignals
                maxDollarAllocationPerSignal
                maxNumberOfContractsPerSignal
                allOrNone
                multiplier
                __typename
              }
              createdAt
              updatedAt
              accountInformationSubAccountsId
              subAccountBalanceId
              __typename
            }
            nextToken
            __typename
          }
          documentUpload {
            items {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              investigationId
              investigationNote
              submittedBy
              document {
                documentTag
                documentType
                s3uri
                __typename
              }
              approvedBy
              approvalStatus
              createdAt
              updatedAt
              accountInformationDocumentUploadId
              __typename
            }
            nextToken
            __typename
          }
          cryptoTransfer {
            items {
              id
              accountNumber
              owner
              blockchainHash
              clientTransactionId
              currency
              quantity
              receiveAddress {
                hotWalletAddress
                coin
                __typename
              }
              userWalletAddress {
                owner
                address
                nickname
                id
                createdAt
                updatedAt
                __typename
              }
              deposit
              status
              type
              version
              createdAt
              updatedAt
              accountInformationCryptoTransferId
              __typename
            }
            nextToken
            __typename
          }
          selectedWatchlist {
            items {
              id
              accountNumber
              owner
              watchListName
              selectedStocks
              createdAt
              updatedAt
              accountInformationSelectedWatchlistId
              __typename
            }
            nextToken
            __typename
          }
          notifications {
            items {
              id
              accountNumber
              owner
              notificationType
              message
              severity
              acknowledged
              star
              sent
              deleted
              toUser
              fromUser
              fromSystem
              ttl
              createdAt
              updatedAt
              accountInformationNotificationsId
              __typename
            }
            nextToken
            __typename
          }
          achRelationship {
            id
            accountNumber
            owner
            accountInformation {
              id
              primaryOwner
              owner
              accountNumber
              accountName
              accountType
              customerType
              accountRequestStatus
              investigationStatus
              apexId
              apexFdid
              apexCatAccountholderType
              apexJson
              accountStatus
              balance {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                overnightBuyingPowerID
                firm
                totalEquity
                marginEquity
                marginRequirement
                marginExcessEquity
                cashEquity
                cashRequirement
                cashExcessEquity
                overnightBuyingPowerIssued
                dayTradeBuyingPowerIssued
                regTBuyingPowerIssued
                overnightFactorIssued
                dayTradeFactorIssued
                marginEquityPercent
                positionMarketValue
                longEquityMarketValue
                shortEquityMarketValue
                longOptionMarketValue
                shortOptionMarketValue
                totalTradeBalance
                totalSettleBalance
                cashTradeBalance
                marginTradeBalance
                shortTradeBalance
                cashSettleBalance
                marginSettleBalance
                shortSettleBalance
                moneyMarketSettleBalance
                moneyMarketTradeBalance
                freeCash
                sma
                availableToWithdraw
                optionsRequirement
                nonOptionsRequirement
                lastUpdate
                nonOptionsRequirementNotConcentrated
                typeIUnavailableCashProceeds
                typeIIUnavailableCashProceeds
                netBalance
                smaCommitted
                netLiquidity
                pendingDebitInterest
                pendingDebitDividends
                fullyPaidUnsettledFunds
                cashOnOrders
                buyingPowerOnOrders
                marginExcessEquitySod
                cashExcessEquitySod
                netBalanceSod
                optionBuyingPowerInternal
                stockBuyingPowerInternal
                updateFlag
                accountType
                pendingTransfers {
                  deposit
                  amount
                  achDepositWithdrawalRequestId
                  __typename
                }
                createdAt
                updatedAt
                balanceAccountInformationId
                __typename
              }
              permissions {
                id
                accountNumber
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                owner
                systemAccess
                equityTrading
                optionsTrading
                cryptoTrading
                margin
                securitiesLending
                optionsLevel
                exitOnlyTrades
                restrictReason
                allowCancelOrder
                allowModifyOrder
                achWithdrawal
                patternDayTrader
                achApproval
                profileStatus
                betaFeatures
                achDeposit
                updatedBy
                createdAt
                updatedAt
                userPermissionsAccountInformationId
                __typename
              }
              userOrders {
                items {
                  id
                  accountNumber
                  owner
                  subAccountNumber
                  cancel
                  cancelReplace
                  createdDate
                  updatedDate
                  commission
                  feesAndCommission
                  symbol
                  side
                  brokerSkipChecks
                  brokerOverride
                  brokerId
                  quantity
                  limitPrice
                  stopPrice
                  stockValue
                  originalOrderId
                  strategy
                  avgPx
                  orderType
                  timeInForce
                  instruction
                  userOrderLegs {
                    legType
                    side
                    quantity
                    expiration
                    strike
                    openClose
                    bid
                    ask
                    sharesPerContract
                    avgPx
                    __typename
                  }
                  cashSecured
                  cashSecuredAmount
                  message
                  submitStatus
                  status
                  executionReports {
                    nextToken
                    __typename
                  }
                  cryptoOrder
                  groupUploadOrderId
                  reviewStatus
                  createdAt
                  updatedAt
                  groupUpload {
                    id
                    name
                    description
                    owner
                    isPlaced
                    isPlacedString
                    isAvgPx
                    createdAt
                    updatedAt
                    __typename
                  }
                  accountInformationUserOrdersId
                  userOrderGroupUploadId
                  __typename
                }
                nextToken
                __typename
              }
              positions {
                items {
                  id
                  accountNumber
                  owner
                  underlying
                  pricePaid
                  isCryptoPosition
                  quantity
                  marginRequirement
                  strategy
                  positionLegs {
                    side
                    quantity
                    ratioQuantity
                    pricePaid
                    legType
                    cusip
                    marginRequirement
                    expiration
                    strike
                    __typename
                  }
                  subAccountNumber
                  status
                  groupUploadOrderId
                  createdAt
                  updatedAt
                  accountInformationPositionsId
                  __typename
                }
                nextToken
                __typename
              }
              subAccounts {
                items {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  selfDirected
                  balance {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    accountType
                    createdAt
                    updatedAt
                    __typename
                  }
                  transfers {
                    nextToken
                    __typename
                  }
                  commissionCode
                  repCode
                  newsLetter {
                    newsLetter
                    portfolio
                    __typename
                  }
                  stock {
                    stockSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfSharesPerSignal
                    allOrNone
                    roundLotsOnly
                    multiplier
                    __typename
                  }
                  option {
                    optionSignals
                    maxDollarAllocationPerSignal
                    maxNumberOfContractsPerSignal
                    allOrNone
                    multiplier
                    __typename
                  }
                  createdAt
                  updatedAt
                  accountInformationSubAccountsId
                  subAccountBalanceId
                  __typename
                }
                nextToken
                __typename
              }
              documentUpload {
                items {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  investigationId
                  investigationNote
                  submittedBy
                  document {
                    documentTag
                    documentType
                    s3uri
                    __typename
                  }
                  approvedBy
                  approvalStatus
                  createdAt
                  updatedAt
                  accountInformationDocumentUploadId
                  __typename
                }
                nextToken
                __typename
              }
              cryptoTransfer {
                items {
                  id
                  accountNumber
                  owner
                  blockchainHash
                  clientTransactionId
                  currency
                  quantity
                  receiveAddress {
                    hotWalletAddress
                    coin
                    __typename
                  }
                  userWalletAddress {
                    owner
                    address
                    nickname
                    id
                    createdAt
                    updatedAt
                    __typename
                  }
                  deposit
                  status
                  type
                  version
                  createdAt
                  updatedAt
                  accountInformationCryptoTransferId
                  __typename
                }
                nextToken
                __typename
              }
              selectedWatchlist {
                items {
                  id
                  accountNumber
                  owner
                  watchListName
                  selectedStocks
                  createdAt
                  updatedAt
                  accountInformationSelectedWatchlistId
                  __typename
                }
                nextToken
                __typename
              }
              notifications {
                items {
                  id
                  accountNumber
                  owner
                  notificationType
                  message
                  severity
                  acknowledged
                  star
                  sent
                  deleted
                  toUser
                  fromUser
                  fromSystem
                  ttl
                  createdAt
                  updatedAt
                  accountInformationNotificationsId
                  __typename
                }
                nextToken
                __typename
              }
              achRelationship {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                achRelationshipStatic {
                  id
                  accountNumber
                  owner
                  plaidProcessorToken
                  plaidAccountId
                  bankRoutingNumber
                  bankAccount
                  bankAccountOwnerName
                  bankAccountType
                  deleted
                  approvalMethod
                  relationshipId
                  status
                  statusCode
                  statusJson
                  createdAt
                  updatedAt
                  __typename
                }
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                depositWithdrawalRequests {
                  items {
                    id
                    accountNumber
                    owner
                    relationshipId
                    amount
                    message
                    memo
                    reason
                    isFullDisbursement
                    transferId
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    achRelationshipDepositWithdrawalRequestsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
                __typename
              }
              userProfileIds
              createdAt
              updatedAt
              userProfileAccountsId
              draftUserProfileAccountsId
              accountInformationBalanceId
              accountInformationPermissionsId
              accountInformationAchRelationshipId
              __typename
            }
            achRelationshipStatic {
              id
              accountNumber
              owner
              plaidProcessorToken
              plaidAccountId
              bankRoutingNumber
              bankAccount
              bankAccountOwnerName
              bankAccountType
              deleted
              approvalMethod
              relationshipId
              status
              statusCode
              statusJson
              createdAt
              updatedAt
              __typename
            }
            deleted
            nickname
            microDepositTries
            microDeposits
            microDepositStatus
            depositWithdrawalRequests {
              items {
                id
                accountNumber
                owner
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                relationshipId
                amount
                message
                memo
                reason
                iraContributionDistribution {
                  contributionType
                  applyToPriorYear
                  distributionReason
                  federalTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  stateTaxWithholding {
                    valueType
                    value
                    __typename
                  }
                  __typename
                }
                isFullDisbursement
                transferId
                deposit
                status
                cancel
                createdAt
                updatedAt
                achRelationshipDepositWithdrawalRequestsId
                __typename
              }
              nextToken
              __typename
            }
            reissueTries
            reissue
            createdAt
            updatedAt
            achRelationshipAchRelationshipStaticId
            achRelationshipAccountInformationId
            __typename
          }
          userProfileIds
          createdAt
          updatedAt
          userProfileAccountsId
          draftUserProfileAccountsId
          accountInformationBalanceId
          accountInformationPermissionsId
          accountInformationAchRelationshipId
          __typename
        }
        nextToken
        __typename
      }
      accountNumbers
      status
      visaType
      visaExpirationDate
      permanentResident
      isCorrespondentEmployee
      custodianType
      custodialState
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        isUSEntity
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          citizenshipCountry
          emailAddress
          isUsCitizen
          __typename
        }
        accountNature
        __typename
      }
      authorizedSignerTitle
      isUsCitizen
      isForeignBank
      isForeignShellBank
      foreignBankUSAgent
      isMaintainedForForeignFinancialInstitution
      offersServicesToForeignShellBank
      dividendReinvestment
      trusteeTaxId
      trusteeIsUsCitizen
      entityTrust {
        trustName
        isPabAccount
        dateOfTrustCreation
        trustTaxId
        legalAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        __typename
      }
      oatsAccountholderType
      issuerDirectCommunicationCode
      entityCertOfTrust {
        trustTitle
        trustEffectiveDate
        trustSitusState
        trustRevocability
        trustees {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          socialSecurityNumber
          identificationNumber
          identification {
            number
            documentType
            issuedBy
            issueDate
            snapId
            expirationDate
            s3Uri
            __typename
          }
          __typename
        }
        trustDocumentSnapId
        trustDocumentS3Uri
        trustAgreementAllowsOptions
        trustAgreementAllowsMarginsAndShortPositions
        __typename
      }
      membersAndManagers {
        legalName
        organizationalRole
        isManager
        __typename
      }
      resolutionAdoptionDate
      authorizedSignerName
      secretaryName
      applicants {
        citizenshipCountry
        birthCountry
        dateOfBirth
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        foreignTaxIdCountry
        foreignTaxIdNumber
        socialSecurityNumber
        visaType
        visaExpirationDate
        permanentResident
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        __typename
      }
      communityPropertyState
      jointType
      jointTenantsInCommonParticipants {
        name
        estatePercent
        __typename
      }
      birthCountry
      foreignTaxIdCountry
      foreignTaxIdNumber
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
      typeIra
      brokerageFirmAuthorization
      decedentName
      simpleIraPlanName
      iraBeneficialOwners {
        givenName
        familyName
        beneficiaryType
        sharePercent
        relationship
        socialSecurityNumber
        __typename
      }
      adoptingEmployer {
        name
        businessAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        phoneNumber
        taxId
        __typename
      }
      planInfo {
        name
        date
        administrator
        __typename
      }
      participantType
      articlesOfIncorporationOrOperatingAgreementSnapId
      articlesOfIncorporationSnapId
      articlesOfIncorporationOrOperatingAgreementS3uri
      articlesOfIncorporationS3uri
      isFinishedOnboarding
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDraftUserProfiles = /* GraphQL */ `
  query ListDraftUserProfiles(
    $id: ID
    $filter: ModelDraftUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDraftUserProfiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        cognitoId
        owner
        userAccountType
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        isFinishedOnboarding
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const draftUserProfileByMemberStatus = /* GraphQL */ `
  query DraftUserProfileByMemberStatus(
    $memberStatus: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDraftUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    draftUserProfileByMemberStatus(
      memberStatus: $memberStatus
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        owner
        userAccountType
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        isFinishedOnboarding
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const draftUserProfileBySocialSecurityNumber = /* GraphQL */ `
  query DraftUserProfileBySocialSecurityNumber(
    $socialSecurityNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDraftUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    draftUserProfileBySocialSecurityNumber(
      socialSecurityNumber: $socialSecurityNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        owner
        userAccountType
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        isFinishedOnboarding
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchDraftUserProfiles = /* GraphQL */ `
  query SearchDraftUserProfiles(
    $filter: SearchableDraftUserProfileFilterInput
    $sort: [SearchableDraftUserProfileSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableDraftUserProfileAggregationInput]
  ) {
    searchDraftUserProfiles(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        cognitoId
        owner
        userAccountType
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accounts {
          items {
            id
            primaryOwner
            owner
            accountNumber
            accountName
            accountType
            customerType
            accountRequestStatus
            investigationStatus
            apexId
            apexFdid
            apexCatAccountholderType
            apexJson
            accountStatus
            balance {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              updateFlag
              accountType
              pendingTransfers {
                deposit
                amount
                achDepositWithdrawalRequestId
                __typename
              }
              createdAt
              updatedAt
              balanceAccountInformationId
              __typename
            }
            permissions {
              id
              accountNumber
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              owner
              systemAccess
              equityTrading
              optionsTrading
              cryptoTrading
              margin
              securitiesLending
              optionsLevel
              exitOnlyTrades
              restrictReason
              allowCancelOrder
              allowModifyOrder
              achWithdrawal
              patternDayTrader
              achApproval
              profileStatus
              betaFeatures
              achDeposit
              updatedBy
              createdAt
              updatedAt
              userPermissionsAccountInformationId
              __typename
            }
            userOrders {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                cancel
                cancelReplace
                createdDate
                updatedDate
                commission
                feesAndCommission
                symbol
                side
                brokerSkipChecks
                brokerOverride
                brokerId
                quantity
                limitPrice
                stopPrice
                stockValue
                originalOrderId
                strategy
                avgPx
                orderType
                timeInForce
                instruction
                userOrderLegs {
                  legType
                  side
                  quantity
                  expiration
                  strike
                  openClose
                  bid
                  ask
                  sharesPerContract
                  avgPx
                  __typename
                }
                cashSecured
                cashSecuredAmount
                message
                submitStatus
                status
                executionReports {
                  items {
                    id
                    owner
                    accountInformationId
                    subAccountNumber
                    orderID
                    executionIncrementId
                    secondaryOrderID
                    clOrdID
                    origClOrdID
                    clientID
                    execBroker
                    listID
                    execID
                    execTransType
                    execRefID
                    execType
                    ordStatus
                    ordRejReason
                    execRestatementReason
                    account
                    settlmntTyp
                    futSettDate
                    symbol
                    symbolSfx
                    securityID
                    iDSource
                    securityType
                    maturityMonthYear
                    maturityDay
                    putOrCall
                    strikePrice
                    optAttribute
                    contractMultiplier
                    couponRate
                    securityExchange
                    issuer
                    encodedIssuerLen
                    encodedIssuer
                    securityDesc
                    encodedSecurityDescLen
                    encodedSecurityDesc
                    side
                    orderQty
                    cashOrderQty
                    ordType
                    price
                    stopPx
                    pegDifference
                    discretionInst
                    discretionOffset
                    currency
                    complianceID
                    solicitedFlag
                    timeInForce
                    effectiveTime
                    expireDate
                    expireTime
                    execInst
                    rule80A
                    lastShares
                    lastPx
                    lastSpotRate
                    lastForwardPoints
                    lastMkt
                    tradingSessionID
                    lastCapacity
                    leavesQty
                    cumQty
                    avgPx
                    dayOrderQty
                    dayCumQty
                    dayAvgPx
                    gTBookingInst
                    tradeDate
                    transactTime
                    reportToExch
                    commission
                    commType
                    grossTradeAmt
                    settlCurrAmt
                    settlCurrency
                    settlCurrFxRate
                    settlCurrFxRateCalc
                    handlInst
                    minQty
                    maxFloor
                    openClose
                    maxShow
                    text
                    encodedTextLen
                    encodedText
                    futSettDate2
                    orderQty2
                    clearingFirm
                    clearingAccount
                    multiLegReportingType
                    legRefId
                    uploadedToBackoffice
                    fixMessage
                    isAllocation
                    groupUploadId
                    processedAt
                    createdDate
                    createdAt
                    updatedAt
                    userOrderExecutionReportsId
                    groupOrderExecutionReportsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoOrder
                groupUploadOrderId
                reviewStatus
                createdAt
                updatedAt
                groupUpload {
                  id
                  name
                  description
                  orders {
                    nextToken
                    __typename
                  }
                  owner
                  isPlaced
                  isPlacedString
                  isAvgPx
                  createdAt
                  updatedAt
                  __typename
                }
                accountInformationUserOrdersId
                userOrderGroupUploadId
                __typename
              }
              nextToken
              __typename
            }
            positions {
              items {
                id
                accountNumber
                owner
                underlying
                pricePaid
                isCryptoPosition
                quantity
                marginRequirement
                strategy
                positionLegs {
                  side
                  quantity
                  ratioQuantity
                  pricePaid
                  legType
                  cusip
                  marginRequirement
                  expiration
                  strike
                  __typename
                }
                subAccountNumber
                status
                groupUploadOrderId
                createdAt
                updatedAt
                accountInformationPositionsId
                __typename
              }
              nextToken
              __typename
            }
            subAccounts {
              items {
                id
                accountNumber
                owner
                subAccountName
                subAccountNumber
                selfDirected
                balance {
                  id
                  accountNumber
                  owner
                  subAccountName
                  subAccountNumber
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  accountType
                  createdAt
                  updatedAt
                  __typename
                }
                transfers {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    toSubAccountNumber
                    amount
                    message
                    deposit
                    status
                    cancel
                    createdAt
                    updatedAt
                    subAccountTransfersId
                    __typename
                  }
                  nextToken
                  __typename
                }
                commissionCode
                repCode
                newsLetter {
                  newsLetter
                  portfolio
                  __typename
                }
                stock {
                  stockSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfSharesPerSignal
                  allOrNone
                  roundLotsOnly
                  multiplier
                  __typename
                }
                option {
                  optionSignals
                  maxDollarAllocationPerSignal
                  maxNumberOfContractsPerSignal
                  allOrNone
                  multiplier
                  __typename
                }
                createdAt
                updatedAt
                accountInformationSubAccountsId
                subAccountBalanceId
                __typename
              }
              nextToken
              __typename
            }
            documentUpload {
              items {
                id
                accountNumber
                owner
                accountInformation {
                  id
                  primaryOwner
                  owner
                  accountNumber
                  accountName
                  accountType
                  customerType
                  accountRequestStatus
                  investigationStatus
                  apexId
                  apexFdid
                  apexCatAccountholderType
                  apexJson
                  accountStatus
                  balance {
                    id
                    accountNumber
                    owner
                    overnightBuyingPowerID
                    firm
                    totalEquity
                    marginEquity
                    marginRequirement
                    marginExcessEquity
                    cashEquity
                    cashRequirement
                    cashExcessEquity
                    overnightBuyingPowerIssued
                    dayTradeBuyingPowerIssued
                    regTBuyingPowerIssued
                    overnightFactorIssued
                    dayTradeFactorIssued
                    marginEquityPercent
                    positionMarketValue
                    longEquityMarketValue
                    shortEquityMarketValue
                    longOptionMarketValue
                    shortOptionMarketValue
                    totalTradeBalance
                    totalSettleBalance
                    cashTradeBalance
                    marginTradeBalance
                    shortTradeBalance
                    cashSettleBalance
                    marginSettleBalance
                    shortSettleBalance
                    moneyMarketSettleBalance
                    moneyMarketTradeBalance
                    freeCash
                    sma
                    availableToWithdraw
                    optionsRequirement
                    nonOptionsRequirement
                    lastUpdate
                    nonOptionsRequirementNotConcentrated
                    typeIUnavailableCashProceeds
                    typeIIUnavailableCashProceeds
                    netBalance
                    smaCommitted
                    netLiquidity
                    pendingDebitInterest
                    pendingDebitDividends
                    fullyPaidUnsettledFunds
                    cashOnOrders
                    buyingPowerOnOrders
                    marginExcessEquitySod
                    cashExcessEquitySod
                    netBalanceSod
                    optionBuyingPowerInternal
                    stockBuyingPowerInternal
                    updateFlag
                    accountType
                    createdAt
                    updatedAt
                    balanceAccountInformationId
                    __typename
                  }
                  permissions {
                    id
                    accountNumber
                    owner
                    systemAccess
                    equityTrading
                    optionsTrading
                    cryptoTrading
                    margin
                    securitiesLending
                    optionsLevel
                    exitOnlyTrades
                    restrictReason
                    allowCancelOrder
                    allowModifyOrder
                    achWithdrawal
                    patternDayTrader
                    achApproval
                    profileStatus
                    betaFeatures
                    achDeposit
                    updatedBy
                    createdAt
                    updatedAt
                    userPermissionsAccountInformationId
                    __typename
                  }
                  userOrders {
                    nextToken
                    __typename
                  }
                  positions {
                    nextToken
                    __typename
                  }
                  subAccounts {
                    nextToken
                    __typename
                  }
                  documentUpload {
                    nextToken
                    __typename
                  }
                  cryptoTransfer {
                    nextToken
                    __typename
                  }
                  selectedWatchlist {
                    nextToken
                    __typename
                  }
                  notifications {
                    nextToken
                    __typename
                  }
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  userProfileIds
                  createdAt
                  updatedAt
                  userProfileAccountsId
                  draftUserProfileAccountsId
                  accountInformationBalanceId
                  accountInformationPermissionsId
                  accountInformationAchRelationshipId
                  __typename
                }
                investigationId
                investigationNote
                submittedBy
                document {
                  documentTag
                  documentType
                  s3uri
                  __typename
                }
                approvedBy
                approvalStatus
                createdAt
                updatedAt
                accountInformationDocumentUploadId
                __typename
              }
              nextToken
              __typename
            }
            cryptoTransfer {
              items {
                id
                accountNumber
                owner
                blockchainHash
                clientTransactionId
                currency
                quantity
                receiveAddress {
                  hotWalletAddress
                  coin
                  __typename
                }
                userWalletAddress {
                  owner
                  address
                  nickname
                  id
                  createdAt
                  updatedAt
                  __typename
                }
                deposit
                status
                type
                version
                createdAt
                updatedAt
                accountInformationCryptoTransferId
                __typename
              }
              nextToken
              __typename
            }
            selectedWatchlist {
              items {
                id
                accountNumber
                owner
                watchListName
                selectedStocks
                createdAt
                updatedAt
                accountInformationSelectedWatchlistId
                __typename
              }
              nextToken
              __typename
            }
            notifications {
              items {
                id
                accountNumber
                owner
                notificationType
                message
                severity
                acknowledged
                star
                sent
                deleted
                toUser
                fromUser
                fromSystem
                ttl
                createdAt
                updatedAt
                accountInformationNotificationsId
                __typename
              }
              nextToken
              __typename
            }
            achRelationship {
              id
              accountNumber
              owner
              accountInformation {
                id
                primaryOwner
                owner
                accountNumber
                accountName
                accountType
                customerType
                accountRequestStatus
                investigationStatus
                apexId
                apexFdid
                apexCatAccountholderType
                apexJson
                accountStatus
                balance {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  overnightBuyingPowerID
                  firm
                  totalEquity
                  marginEquity
                  marginRequirement
                  marginExcessEquity
                  cashEquity
                  cashRequirement
                  cashExcessEquity
                  overnightBuyingPowerIssued
                  dayTradeBuyingPowerIssued
                  regTBuyingPowerIssued
                  overnightFactorIssued
                  dayTradeFactorIssued
                  marginEquityPercent
                  positionMarketValue
                  longEquityMarketValue
                  shortEquityMarketValue
                  longOptionMarketValue
                  shortOptionMarketValue
                  totalTradeBalance
                  totalSettleBalance
                  cashTradeBalance
                  marginTradeBalance
                  shortTradeBalance
                  cashSettleBalance
                  marginSettleBalance
                  shortSettleBalance
                  moneyMarketSettleBalance
                  moneyMarketTradeBalance
                  freeCash
                  sma
                  availableToWithdraw
                  optionsRequirement
                  nonOptionsRequirement
                  lastUpdate
                  nonOptionsRequirementNotConcentrated
                  typeIUnavailableCashProceeds
                  typeIIUnavailableCashProceeds
                  netBalance
                  smaCommitted
                  netLiquidity
                  pendingDebitInterest
                  pendingDebitDividends
                  fullyPaidUnsettledFunds
                  cashOnOrders
                  buyingPowerOnOrders
                  marginExcessEquitySod
                  cashExcessEquitySod
                  netBalanceSod
                  optionBuyingPowerInternal
                  stockBuyingPowerInternal
                  updateFlag
                  accountType
                  pendingTransfers {
                    deposit
                    amount
                    achDepositWithdrawalRequestId
                    __typename
                  }
                  createdAt
                  updatedAt
                  balanceAccountInformationId
                  __typename
                }
                permissions {
                  id
                  accountNumber
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  owner
                  systemAccess
                  equityTrading
                  optionsTrading
                  cryptoTrading
                  margin
                  securitiesLending
                  optionsLevel
                  exitOnlyTrades
                  restrictReason
                  allowCancelOrder
                  allowModifyOrder
                  achWithdrawal
                  patternDayTrader
                  achApproval
                  profileStatus
                  betaFeatures
                  achDeposit
                  updatedBy
                  createdAt
                  updatedAt
                  userPermissionsAccountInformationId
                  __typename
                }
                userOrders {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountNumber
                    cancel
                    cancelReplace
                    createdDate
                    updatedDate
                    commission
                    feesAndCommission
                    symbol
                    side
                    brokerSkipChecks
                    brokerOverride
                    brokerId
                    quantity
                    limitPrice
                    stopPrice
                    stockValue
                    originalOrderId
                    strategy
                    avgPx
                    orderType
                    timeInForce
                    instruction
                    cashSecured
                    cashSecuredAmount
                    message
                    submitStatus
                    status
                    cryptoOrder
                    groupUploadOrderId
                    reviewStatus
                    createdAt
                    updatedAt
                    accountInformationUserOrdersId
                    userOrderGroupUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                positions {
                  items {
                    id
                    accountNumber
                    owner
                    underlying
                    pricePaid
                    isCryptoPosition
                    quantity
                    marginRequirement
                    strategy
                    subAccountNumber
                    status
                    groupUploadOrderId
                    createdAt
                    updatedAt
                    accountInformationPositionsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                subAccounts {
                  items {
                    id
                    accountNumber
                    owner
                    subAccountName
                    subAccountNumber
                    selfDirected
                    commissionCode
                    repCode
                    createdAt
                    updatedAt
                    accountInformationSubAccountsId
                    subAccountBalanceId
                    __typename
                  }
                  nextToken
                  __typename
                }
                documentUpload {
                  items {
                    id
                    accountNumber
                    owner
                    investigationId
                    investigationNote
                    submittedBy
                    approvedBy
                    approvalStatus
                    createdAt
                    updatedAt
                    accountInformationDocumentUploadId
                    __typename
                  }
                  nextToken
                  __typename
                }
                cryptoTransfer {
                  items {
                    id
                    accountNumber
                    owner
                    blockchainHash
                    clientTransactionId
                    currency
                    quantity
                    deposit
                    status
                    type
                    version
                    createdAt
                    updatedAt
                    accountInformationCryptoTransferId
                    __typename
                  }
                  nextToken
                  __typename
                }
                selectedWatchlist {
                  items {
                    id
                    accountNumber
                    owner
                    watchListName
                    selectedStocks
                    createdAt
                    updatedAt
                    accountInformationSelectedWatchlistId
                    __typename
                  }
                  nextToken
                  __typename
                }
                notifications {
                  items {
                    id
                    accountNumber
                    owner
                    notificationType
                    message
                    severity
                    acknowledged
                    star
                    sent
                    deleted
                    toUser
                    fromUser
                    fromSystem
                    ttl
                    createdAt
                    updatedAt
                    accountInformationNotificationsId
                    __typename
                  }
                  nextToken
                  __typename
                }
                achRelationship {
                  id
                  accountNumber
                  owner
                  accountInformation {
                    id
                    primaryOwner
                    owner
                    accountNumber
                    accountName
                    accountType
                    customerType
                    accountRequestStatus
                    investigationStatus
                    apexId
                    apexFdid
                    apexCatAccountholderType
                    apexJson
                    accountStatus
                    userProfileIds
                    createdAt
                    updatedAt
                    userProfileAccountsId
                    draftUserProfileAccountsId
                    accountInformationBalanceId
                    accountInformationPermissionsId
                    accountInformationAchRelationshipId
                    __typename
                  }
                  achRelationshipStatic {
                    id
                    accountNumber
                    owner
                    plaidProcessorToken
                    plaidAccountId
                    bankRoutingNumber
                    bankAccount
                    bankAccountOwnerName
                    bankAccountType
                    deleted
                    approvalMethod
                    relationshipId
                    status
                    statusCode
                    statusJson
                    createdAt
                    updatedAt
                    __typename
                  }
                  deleted
                  nickname
                  microDepositTries
                  microDeposits
                  microDepositStatus
                  depositWithdrawalRequests {
                    nextToken
                    __typename
                  }
                  reissueTries
                  reissue
                  createdAt
                  updatedAt
                  achRelationshipAchRelationshipStaticId
                  achRelationshipAccountInformationId
                  __typename
                }
                userProfileIds
                createdAt
                updatedAt
                userProfileAccountsId
                draftUserProfileAccountsId
                accountInformationBalanceId
                accountInformationPermissionsId
                accountInformationAchRelationshipId
                __typename
              }
              achRelationshipStatic {
                id
                accountNumber
                owner
                plaidProcessorToken
                plaidAccountId
                bankRoutingNumber
                bankAccount
                bankAccountOwnerName
                bankAccountType
                deleted
                approvalMethod
                relationshipId
                status
                statusCode
                statusJson
                createdAt
                updatedAt
                __typename
              }
              deleted
              nickname
              microDepositTries
              microDeposits
              microDepositStatus
              depositWithdrawalRequests {
                items {
                  id
                  accountNumber
                  owner
                  achRelationship {
                    id
                    accountNumber
                    owner
                    deleted
                    nickname
                    microDepositTries
                    microDeposits
                    microDepositStatus
                    reissueTries
                    reissue
                    createdAt
                    updatedAt
                    achRelationshipAchRelationshipStaticId
                    achRelationshipAccountInformationId
                    __typename
                  }
                  relationshipId
                  amount
                  message
                  memo
                  reason
                  iraContributionDistribution {
                    contributionType
                    applyToPriorYear
                    distributionReason
                    __typename
                  }
                  isFullDisbursement
                  transferId
                  deposit
                  status
                  cancel
                  createdAt
                  updatedAt
                  achRelationshipDepositWithdrawalRequestsId
                  __typename
                }
                nextToken
                __typename
              }
              reissueTries
              reissue
              createdAt
              updatedAt
              achRelationshipAchRelationshipStaticId
              achRelationshipAccountInformationId
              __typename
            }
            userProfileIds
            createdAt
            updatedAt
            userProfileAccountsId
            draftUserProfileAccountsId
            accountInformationBalanceId
            accountInformationPermissionsId
            accountInformationAchRelationshipId
            __typename
          }
          nextToken
          __typename
        }
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            citizenshipCountry
            emailAddress
            isUsCitizen
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        isFinishedOnboarding
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
